<template>
  <v-flex>
    <v-row class="mt-n7" v-if="!loading" justify="center" no-gutters>
      <v-col cols="12" md="10">
        <v-container v-if="data_invoice != null" fluid>
          <v-row no-gutters class="mb-4 align-center animate__animated animate__fadeIn">
            <v-col>
              <div class="d-flex align-center flex-wrap" style="gap: 8px 20px;">
                <h1 class="text-h6 text-md-h4 font-weight-black grey--text text--darken-4 d-flex align-center flex-wrap mb-0">
                  {{ formTitle }}
                  <span class="mx-3 grey--text text--lighten-2 font-weight-thin">/</span>
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="primary--text glow-text copy-invoice-number d-inline-flex align-center"
                        @click="copyInvoiceNumber">
                        #{{ data_invoice?.invoice_number }}
                        <v-icon small color="primary" class="ml-2 copy-icon">mdi-content-copy</v-icon>
                      </span>
                    </template>
                    <span>Clic para copiar</span>
                  </v-tooltip>
                </h1>
                <v-chip v-if="data_invoice.status_id != 1" color="error" dark class="font-weight-black elevation-1"
                  label>
                  <v-icon left small>mdi-cancel</v-icon> ANULADA
                </v-chip>
                <v-chip v-else color="#2d8575" dark class="font-weight-black elevation-2" label>
                  <v-icon left small>mdi-check-circle</v-icon> COMPROBANTE ACTIVO
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters class="mb-3 mx-2 align-center" justify="start">
            <v-btn @click="beforeRoute" v-if="hasPreviousPage" depressed class="mr-2 rounded-lg text-capitalize px-4"
              color="primary " text-color="primary">
              <v-icon left size="20">mdi-arrow-left</v-icon>
              Volver
            </v-btn>

            <div class="d-flex align-center flex-wrap bg-white rounded-lg px-1 py-1 border ml-2 mt-2 mt-md-0">
              <v-btn v-if="data_invoice.status_id == 1" @click="downloadInvoice" text
                class="rounded-lg text-capitalize px-4" color="primary">
                <v-icon left size="18">mdi-printer-outline</v-icon>
                Imprimir
              </v-btn>
              <v-divider vertical class="mx-1 my-2"></v-divider>
              <v-btn v-if="data_invoice.status_id == 1" @click="downloadInvoiceExcel" text
                class="rounded-lg text-capitalize px-4" color="success">
                <v-icon left size="18">mdi-file-excel-outline</v-icon>
                Excel
              </v-btn>
              <v-divider vertical
                v-if="(data_invoice.status_id == 1) && [1, 4].includes(data_invoice?.invoice_type_id) && can_edit_invoice"
                class="mx-1 my-2"></v-divider>
              <v-btn v-if="(data_invoice.status_id == 1) && [1, 4].includes(data_invoice?.invoice_type_id) && can_edit_invoice"
                @click="dialogCampos = true" text class="rounded-lg text-capitalize px-4" color="grey darken-2">
                <v-icon left size="18">mdi-square-edit-outline</v-icon>
                Editar
              </v-btn>
            </div>

            <v-btn v-if="
              data_invoice.status_id == 1 &&
              data_invoice.recorded == false &&
              $store.state.auth.globalFeatures.includes('ING-023')
            " @click="dialogCancelInvoice = true" depressed class="ml-4 mt-2 mt-md-0 rounded-lg text-capitalize px-4"
              color="error lighten-5" text-color="error">
              <v-icon left size="20">mdi-trash-can-outline</v-icon>
              Anular DocumentO
            </v-btn>

            <v-btn v-if="data_invoice?.invoice_type_id == 5 && data_invoice.status_order_id == 1" depressed
              class="ml-4 rounded-lg text-capitalize px-4" color="blue lighten-5" text-color="blue font-weight-bold">
              <v-icon left size="20">mdi-package-variant-closed</v-icon>
              Mover a empacado
            </v-btn>
            <v-btn v-if="data_invoice?.invoice_type_id == 5 && data_invoice.status_order_id == 2" depressed
              class="ml-4 rounded-lg text-capitalize px-4" color="success lighten-5"
              text-color="success darken-2 font-weight-bold">
              <v-icon left size="20">mdi-truck-delivery-outline</v-icon>
              Despachar
            </v-btn>

            <v-spacer></v-spacer>
            <div class="d-flex align-center flex-wrap mt-4 mt-md-0">
              <v-btn
                v-if="hasFeature('ING-027') && data_invoice.use_ecf && !is_valid_dgii && data_invoice.invoice_ncf != null"
                @click="sendToDGII" :loading="loading_dgii" :disabled="loading_dgii" depressed
                class="rounded-lg mr-4 text-capitalize px-6" color="primary">
                <v-icon left>mdi-send-check</v-icon>Enviar a DGII
              </v-btn>
              <div class="d-flex align-center gap-2 mr-4">
                <v-chip v-if="data_invoice.use_ecf && is_valid_dgii" color="primary lighten-5" text-color="primary"
                  class="font-weight-black px-4" label>
                  Enviada a DGII
                  <v-icon right small>mdi-certificate</v-icon>
                </v-chip>
                <v-chip v-else-if="data_invoice.use_ecf && !is_valid_dgii && data_invoice.invoice_ncf != null"
                  color="warning lighten-5" text-color="warning darken-2" class="font-weight-black px-4" label>
                  Error DGII
                  <v-icon right small>mdi-alert</v-icon>
                </v-chip>
              </div>

              <div class="d-flex align-center gap-2 flex-wrap mt-2 mt-md-0">
                <v-chip v-if="data_invoice.recorded" color="success lighten-5" text-color="success darken-2"
                  class="font-weight-black px-4" label>
                  <v-icon left small>mdi-check-decagram</v-icon> CONTABILIZADA
                </v-chip>
                <v-chip v-else-if="data_invoice.status_id == 1 && data_invoice?.invoice_type_id <= 4"
                  color="warning lighten-5" text-color="warning darken-2" class="font-weight-black px-4 pulse-active"
                  label>
                  <v-icon left small>mdi-alert-circle-outline</v-icon> PENDIENTE ASIENTO
                </v-chip>

                <v-btn
                  v-if="data_invoice.recorded == false && data_invoice.status_id == 1 && data_invoice?.invoice_type_id != 6"
                  @click="dialogAccountingInvoice = true" depressed class="ml-2 rounded-lg text-capitalize px-6"
                  color="success">
                  <v-icon left>mdi-book-plus-outline</v-icon> Crear Asiento
                </v-btn>

                <v-btn
                  v-else-if="data_invoice.recorded == true && data_invoice.status_id == 1 && data_invoice?.invoice_type_id != 6 && can_descontabilizar"
                  @click="dialogCancelAccountingInvoice = true" depressed class="ml-2 rounded-lg text-capitalize px-4"
                  color="error lighten-2" text-color="error">
                  <v-icon left size="20">mdi-book-remove-outline</v-icon> Anular Asiento
                </v-btn>
              </div>
            </div>
          </v-row>

          <!-- Alert for ECF invoices not sent to DGII -->
          <v-row
            v-if="!loading && data_invoice && data_invoice.use_ecf && !is_valid_dgii && data_invoice.invoice_ncf != null"
            no-gutters justify="center" class="mt-4">
            <v-col cols="12">
              <v-alert type="warning" prominent border="left" colored-border elevation="2">
                <v-row align="center">
                  <v-col class="grow">
                    <div class="text-h6 font-weight-bold">
                      <v-icon large left color="warning">mdi-alert-circle</v-icon>
                      <template v-if="dgii_status">
                        La DGII no ha aceptado esta factura electrónica (e-NCF)
                      </template>
                      <template v-else>
                        Esta factura electrónica (e-NCF) no ha sido enviada a la DGII
                      </template>
                    </div>
                    <div class="mt-2">
                      Es necesario enviar esta factura a la DGII para cumplir con las regulaciones fiscales.
                    </div>
                  </v-col>
                  <v-col class="shrink">

                    <v-btn v-if="hasFeature('ING-027')" @click="sendToDGII" :loading="loading_dgii"
                      :disabled="loading_dgii" color="warning" large elevation="2">
                      <v-icon left>mdi-certificate</v-icon>
                      {{ dgii_status || dgii_send_result ? 'Reenviar a DGII' : 'Enviar a DGII' }}
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Detalle técnico de la DGII: solo para quien puede reenviar -->
                <template v-if="hasFeature('ING-027')">
                <!-- Respuesta del último envío hecho desde esta pantalla -->
                <div v-if="dgii_send_result" class="mt-3 pa-3 rounded-lg dgii-response"
                  :class="dgii_send_result.ok ? 'blue lighten-5' : 'red lighten-5'">
                  <div class="font-weight-bold">
                    <v-icon small left :color="dgii_send_result.ok ? 'primary' : 'error'">
                      {{ dgii_send_result.ok ? 'mdi-information' : 'mdi-close-circle' }}
                    </v-icon>
                    <template v-if="dgii_send_result.stage == 'json'">Error generando el e-CF (no se envió a la API)</template>
                    <template v-else-if="dgii_send_result.status == null">
                      No se pudo conectar con la API DGII desde este equipo/red
                    </template>
                    <template v-else>Respuesta de la API DGII (HTTP {{ dgii_send_result.status }})</template>
                    <span class="caption grey--text text--darken-1 ml-2">{{ getDate(dgii_send_result.date, 1) }}</span>
                  </div>
                  <ul v-if="dgii_send_result.messages.length" class="mt-1">
                    <li v-for="(message, i) in dgii_send_result.messages" :key="i">{{ message }}</li>
                  </ul>
                  <v-btn x-small text color="primary" class="mt-1 px-0" @click="show_dgii_raw = !show_dgii_raw">
                    {{ show_dgii_raw ? 'Ocultar respuesta completa' : 'Ver respuesta completa' }}
                  </v-btn>
                  <pre v-if="show_dgii_raw" class="mt-1 dgii-raw">{{ dgii_send_result.raw }}</pre>
                </div>

                <!-- Último registro guardado por la API DGII para este e-NCF -->
                <div v-if="dgii_status" class="mt-3 pa-3 rounded-lg grey lighten-4 dgii-response">
                  <div class="font-weight-bold">
                    Registro en DGII:
                    <v-chip x-small label class="ml-1 font-weight-bold"
                      :color="(dgii_status.Estado || '').toUpperCase() == 'RECHAZADO' ? 'error' : 'warning'" dark>
                      {{ dgii_status.Estado || 'SIN ESTADO' }}
                    </v-chip>
                  </div>
                  <div class="caption mt-1">
                    Ambiente: <b>{{ dgii_status.Ambiente }}</b>
                    <span v-if="dgii_status.TrackId"> · TrackId: <b>{{ dgii_status.TrackId }}</b></span>
                    <span v-if="dgii_status.IntentosEnvio != null"> · Intentos: <b>{{ dgii_status.IntentosEnvio }}</b></span>
                    · Registrado:
                    <b>{{ getDgiiDate(dgii_status.FechaCreacion) }}</b>
                  </div>
                  <ul v-if="parseDgiiMessage(dgii_status.MensajeRespuesta).mensajes.length" class="mt-1">
                    <li v-for="(message, i) in parseDgiiMessage(dgii_status.MensajeRespuesta).mensajes" :key="'m' + i">
                      <span v-if="message.codigo" class="font-weight-bold">{{ message.codigo }}:</span> {{ message.valor }}
                    </li>
                  </ul>
                  <div v-if="dgii_status.DetalleRespuesta" class="mt-1">{{ dgii_status.DetalleRespuesta }}</div>
                  <div v-if="dgii_status.errors.length" class="mt-2">
                    <div class="caption font-weight-bold">Errores registrados</div>
                    <ul>
                      <li v-for="(error, i) in dgii_status.errors" :key="'e' + i">
                        <span class="caption grey--text text--darken-1">{{ getDate(error.FechaError, 1) }}</span>
                        <span v-if="error.CodigoError" class="font-weight-bold"> {{ error.CodigoError }}:</span>
                        {{ error.DescripcionError }}
                        <span v-if="error.DetalleError"> — {{ error.DetalleError }}</span>
                      </li>
                    </ul>
                  </div>
                  <div v-if="dgii_status.trackings.length" class="mt-2">
                    <div class="caption font-weight-bold">Consultas de seguimiento</div>
                    <ul>
                      <li v-for="(tracking, i) in dgii_status.trackings" :key="'t' + i">
                        <span class="caption grey--text text--darken-1">{{ getDate(tracking.FechaConsulta, 1) }}</span>
                        <b> {{ tracking.Estado }}</b>
                        <span v-if="tracking.MensajeRespuesta"> — {{ tracking.MensajeRespuesta }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else-if="!dgii_send_result" class="mt-3 caption grey--text text--darken-1">
                  No hay ningún registro de este e-NCF en la DGII: el envío no llegó a procesarse.
                </div>
                </template>
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-if="[1, 2, 3, 4].includes(data_invoice?.invoice_type_id)" no-gutters class="mt-4">
            <v-col v-for="(card, index) in summaryCards" :key="index" cols="6" sm="4" md="4" lg="2" class="pa-2">
              <v-card class="summary-card" :class="card.colorClass" outlined>
                <v-card-text class="pa-3">
                  <div class="d-flex align-center mb-1">
                    <v-icon x-small class="mr-2" :color="card.iconColor">{{ card.icon }}</v-icon>
                    <span class="summary-card-title font-weight-bold text-truncate">{{ card.title }}</span>
                  </div>
                  <div class="d-flex align-baseline flex-wrap">
                    <span class="text-subtitle-1 font-weight-black mr-1">{{ currencyFormat(card.value) }}</span>
                    <span class="text-caption font-weight-medium">{{ data_invoice.currency_code }}</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters justify="center">
            <div class="folded_corner mt-2 overflow-hidden position-relative">
              <!-- Watermark Stamps -->
              <!-- <div v-if="data_invoice.status_id != 1" class="status-stamp cancelled">ANULADA</div>
              <div v-else-if="totals_invoices.pending_amount <= 0" class="status-stamp closed">COBRADA</div> -->

              <v-row class="mt-8 px-4 px-md-10 align-center">
                <v-col cols="12" md="3">
                  <v-img contain width="140" height="auto" :src="locationImage" class="mx-auto mx-md-0"></v-img>
                </v-col>

                <v-col cols="12" md="6" class="text-center">
                  <h2 class="text-h5 text-md-h4 font-weight-black grey--text text--darken-4 mb-1 letter-spacing-1">
                    {{ data_invoice.business_unit_description }}
                  </h2>
                  <div class="text-subtitle-1 font-weight-bold grey--text text--darken-1">
                    {{ data_invoice.location_description }}
                  </div>
                </v-col>

                <v-col cols="12" md="3" class="text-center text-md-right d-flex flex-column justify-center mt-4 mt-md-0">
                  <span class="text-h6 text-md-h5 font-weight-black grey--text text--lighten-2 line-height-1 mb-2">#{{
                    data_invoice.invoice_number }}</span>
                  <div>
                    <span class="text-caption grey--text font-weight-bold">Creación:</span>
                    <span class="text-body-2 font-weight-black grey--text text--darken-4 ml-1">{{
                      getDate(data_invoice.created_date, 2) }}</span>
                  </div>
                </v-col>
              </v-row>

              <div class="px-4 px-md-10 mt-6">
                <v-row class="bg-white py-4 rounded-lg border mx-0 align-center shadow-sm">
                  <v-col cols="12" md="7" class="border-right-light pb-4 pb-md-0">
                    <div class="d-flex align-center mb-4">
                      <span class="text-caption grey--text font-weight-bold width-label">{{
                        data_invoice.invoice_type_id == 1 ? 'Proveedor' : 'Cliente' }}:</span>
                      <span
                        class="text-body-1 font-weight-black primary--text text-decoration-underline cursor-pointer ml-3"
                        @click="viewEntity(data_invoice.entity_id)">
                        {{ data_invoice.entity_name }}
                      </span>
                    </div>
                    <div class="d-flex align-center mb-4" v-if="data_invoice.entity_branch_name">
                      <span class="text-caption grey--text font-weight-bold width-label">Sucursal:</span>
                      <span class="text-body-2 font-weight-black grey--text text--darken-4 ml-3">
                        {{ data_invoice.entity_branch_name }}
                      </span>
                    </div>
                    <div class="d-flex align-center mb-4" v-if="data_invoice.responsable_entity_name">
                      <span class="text-caption grey--text font-weight-bold width-label">Responsable:</span>
                      <span class="text-body-2 font-weight-black grey--text text--darken-4 ml-3">
                        {{ data_invoice.responsable_entity_name }}
                      </span>
                    </div>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <div class="d-flex align-center flex-wrap">
                          <span class="text-caption grey--text font-weight-bold width-label">RNC/Cédula:</span>
                          <span class="text-body-2 font-weight-bold grey--text text--darken-3 ml-3">{{
                            data_invoice.entity_document_id }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" v-if="data_invoice.order_id" class="mt-2 mt-sm-0">
                        <div class="d-flex align-center flex-wrap">
                          <span class="text-caption grey--text font-weight-bold width-label">Orden de compra:</span>
                          <span
                            class="text-body-2 font-weight-bold primary--text text-decoration-underline cursor-pointer ml-3"
                            @click="showOrder(data_invoice.order_id, false)">
                            {{ filLeft(data_invoice.order_id.toString(), 12, "0") }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row dense v-if="data_invoice.supplier_invoice_number || data_invoice.supplier_invoice_voucher"
                      class="mt-1">
                      <v-col cols="12" sm="6" v-if="data_invoice.supplier_invoice_number">
                        <div class="d-flex align-center flex-wrap">
                          <span class="text-caption grey--text font-weight-bold width-label">Factura Suplidor:</span>
                          <span class="text-body-2 font-weight-black grey--text text--darken-4 ml-3">{{
                            data_invoice.supplier_invoice_number }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" v-if="data_invoice.supplier_invoice_voucher" class="mt-2 mt-sm-0">
                        <div class="d-flex align-center flex-wrap">
                          <span class="text-caption grey--text font-weight-bold width-label">NCF Suplidor:</span>
                          <span class="text-body-2 font-weight-black grey--text text--darken-4 ml-3">{{
                            data_invoice.supplier_invoice_voucher }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" md="5">
                    <div class="d-flex justify-space-between mb-1 px-4">
                      <span class="text-caption grey--text font-weight-bold">Términos de pago:</span>
                      <span class="text-body-2 font-weight-black grey--text text--darken-4">{{
                        data_invoice.invoice_category_id == 1 ? 'Al contado' : 'A crédito' }}</span>
                    </div>
                    <div class="d-flex justify-space-between mb-1 px-4">
                      <span class="text-caption grey--text font-weight-bold">Almacén:</span>
                      <span class="text-body-2 font-weight-black grey--text text--darken-4">{{
                        data_invoice.warehouse_name || 'N/A' }}</span>
                    </div>
                    <div class="d-flex justify-space-between px-4">
                      <span class="text-caption grey--text font-weight-bold">Proyecto:</span>
                      <span class="text-body-2 font-weight-black grey--text text--darken-4 text-truncate ml-4">{{
                        data_invoice.project_name || 'N/A' }}</span>
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-divider class="mx-4 mx-md-10 my-6"></v-divider>

              <v-row class="px-4 px-md-10 mb-6 mt-n2">
                <v-col cols="12">
                  <div
                    class="ncf-hero-bar py-3 px-4 px-md-6 rounded-lg d-flex flex-wrap align-center justify-space-between gap-2 border position-relative overflow-hidden">
                    <div class="d-flex align-center">
                      <div class="mr-4">
                        <span class="text-overline grey--text font-weight-black d-block mb-n1">{{
                          getDocumentTypeName(data_invoice.invoice_ncf) }}</span>
                        <span class="text-h6 text-md-h5 font-weight-black primary--text letter-spacing-1">{{
                          data_invoice.invoice_ncf || '' }}</span>
                      </div>
                      <v-chip v-if="data_invoice.ncf_invoice_code" color="error lighten-5" text-color="error" label
                        small class="font-weight-black">
                        MODIFICA A: {{ data_invoice.ncf_invoice_code }}
                      </v-chip>
                    </div>

                    <div class="d-flex align-center flex-wrap gap-1 mt-2 mt-md-0">
                      <div class="text-right px-4 border-right-light">
                        <span class="text-overline grey--text font-weight-black d-block line-height-1">Emisión</span>
                        <span class="text-subtitle-2 font-weight-black grey--text text--darken-3">{{
                          getDate(data_invoice.emission_date, 2) }}</span>
                      </div>
                      <div class="text-right px-4 border-right-light" v-if="data_invoice.account_date">
                        <span
                          class="text-overline grey--text font-weight-black d-block line-height-1">Contabilización</span>
                        <span class="text-subtitle-2 font-weight-black grey--text text--darken-3">{{
                          getDate(data_invoice.account_date, 2) }}</span>
                      </div>
                      <div class="text-right pl-4" v-if="data_invoice.expire_at">
                        <span
                          class="text-overline grey--text font-weight-black d-block line-height-1">Vencimiento</span>
                        <span class="text-subtitle-2 font-weight-black"
                          :class="isExpired ? 'error--text pulse-active' : 'grey--text text--darken-3'">
                          {{ getDate(data_invoice.expire_at, 2) }}
                        </span>
                      </div>
                    </div>
                    <div class="ncf-accent-bg"></div>
                  </div>
                </v-col>
              </v-row>

              <v-row v-if="entityAddress || entityShipTo" class="px-4 px-md-10 mt-n4 mb-4">
                <v-col cols="12">
                  <v-alert dense text color="primary lighten-4" class="mb-0 rounded-lg border-primary-light">
                    <v-row no-gutters>
                      <v-col v-if="entityAddress" cols="12" md="6" class="pr-4">
                        <span class="text-overline grey--text font-weight-black d-block mb-1">Dirección de
                          facturación</span>
                        <span class="text-body-2 font-weight-medium grey--text text--darken-4">{{ entityAddress
                          }}</span>
                      </v-col>
                      <v-col v-if="entityShipTo" cols="12" md="6"
                        :class="entityAddress ? 'border-left-primary pl-4' : ''">
                        <span class="text-overline grey--text font-weight-black d-block mb-1">Ship To /
                          Destinatario</span>
                        <span class="text-body-2 font-weight-medium grey--text text--darken-4">{{ entityShipTo }}</span>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-if="hasProductionMetadata" class="px-4 px-md-10 mt-2">
                <v-col cols="12">
                  <div class="production-metadata-bar pa-3 rounded-lg border d-flex flex-wrap gap-6 align-center">
                    <span class="text-overline primary--text font-weight-bold mr-2"><v-icon small color="primary"
                        class="mr-1">mdi-factory</v-icon> Producción:</span>
                    <div v-if="data_invoice.metadata.content" class="meta-item ml-4">
                      <span class="text-caption grey--text font-weight-bold mr-1">Contenido:</span>
                      <span class="text-caption">{{ data_invoice.metadata.content }}</span>
                    </div>
                    <div v-if="data_invoice.metadata.color || data_invoice.metadata.colorName" class="meta-item ml-4">
                      <span class="text-caption grey--text font-weight-bold mr-1">Color:</span>
                      <span class="text-caption">{{ data_invoice.metadata.color }} {{ data_invoice.metadata.colorName
                        }}</span>
                    </div>
                    <div v-if="data_invoice.metadata.yarnLot" class="meta-item ml-4">
                      <span class="text-caption grey--text font-weight-bold mr-1">Lote:</span>
                      <span class="text-caption">{{ data_invoice.metadata.yarnLot }}</span>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-7 px-4 px-md-10">
                <v-col cols="12" class="px-0 px-md-3 overflow-x-auto">
                  <v-data-table :headers="headers" dense :items="groupedInvoiceDetails" :items-per-page="4000"
                    class="elevation-0 rounded-lg custom-table" hide-default-footer show-expand
                    :expanded.sync="expanded" item-key="item_id">
                    <template v-slot:[`item.index`]="{ index }">
                      <span class="text-caption grey--text">{{ index + 1 }}</span>
                    </template>
                    <template v-slot:[`item.item_name`]="{ item }">
                      <div class="d-flex flex-column py-2">
                        <span class="font-weight-black grey--text text--darken-4 uppercase">
                          {{ item.item_description || item.item_name }}
                        </span>
                        <div class="d-flex align-center mt-1" v-if="item.supplier_code">
                          <v-icon x-small color="grey" class="mr-1">mdi-home-modern</v-icon>
                          <span class="text-caption grey--text font-weight-bold uppercase">{{ item.supplier_code
                            }}</span>
                        </div>
                        <span v-if="item.note" class="text-caption grey--text italic mt-1">{{ item.note }}</span>
                      </div>
                    </template>
                    <template v-slot:[`item.measure_metric_description`]="{ item }">
                      <v-chip x-small outlined class="font-weight-bold grey--text text--darken-1" label>
                        {{ item.measure_metric_description || 'UNIDAD' }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                      <div class="d-flex flex-column align-end">
                        <span class="text-caption grey--text line-height-1 mb-1">{{ data_invoice.currency_code }}</span>
                        <span class="font-weight-medium text-body-2">{{ currencyFormat(item.price) }}</span>
                      </div>
                    </template>
                    <template v-slot:[`item.sub_total`]="{ item }">
                      <div class="d-flex flex-column align-end">
                        <span class="text-caption grey--text line-height-1 mb-1">{{ data_invoice.currency_code }}</span>
                        <span class="font-weight-medium text-body-2">{{ currencyFormat(parseFloat(item.price) *
                          parseFloat(item.total_quantity)) }}</span>
                      </div>
                    </template>
                    <template v-slot:[`item.discount`]="{ item }">
                      <span :class="parseFloat(item.discount) > 0 ? 'error--text' : 'grey--text'" class="text-body-2">
                        {{ currencyFormat(parseFloat(item.discount) * parseFloat(item.price) *
                          parseFloat(item.total_quantity)) }}
                      </span>
                    </template>
                    <template v-slot:[`item.itbis`]="{ item }">
                      <span class="grey--text text--darken-1 text-body-2">{{ currencyFormat(parseFloat(item.taxes) *
                        parseFloat(item.total_quantity) * (1 - parseFloat(item.discount))) }}</span>
                    </template>
                    <template v-slot:[`item.total_quantity`]="{ item }">
                      <span class="font-weight-black text-body-2 grey--text text--darken-4">{{ item.total_quantity
                        }}</span>
                    </template>
                    <template v-slot:[`item.total`]="{ item }">
                      <div class="d-flex flex-column align-end">
                        <span class="text-caption grey--text line-height-1 mb-1">{{ data_invoice.currency_code }}</span>
                        <span class="font-weight-black primary--text text-body-1">{{
                          currencyFormat(item.total_amount_sum) }}</span>
                      </div>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="expanded-row-bg">
                        <v-card flat class="ma-4 rounded-lg overflow-hidden border">
                          <v-row no-gutters>
                            <v-col cols="12" md="8" class="border-right">
                              <div class="pa-3 grey lighten-5 font-weight-bold text-caption border-bottom">RECEPCIONES Y
                                MOVIMIENTOS</div>
                              <v-data-table dense :headers="[
                                { text: '# Recepción', value: 'order_entry_id' },
                                { text: 'Fecha', value: 'date_reception' },
                                { text: 'Factura Prov.', value: 'supplier_invoice_number' },
                                { text: 'Almacén', value: 'warehouse_id', align: 'center' },
                                { text: 'Cant.', value: 'quantity', align: 'right' },
                                { text: 'Total', value: 'total_amount', align: 'right' }
                              ]" :items="item.details" hide-default-footer class="inner-table">
                                <template v-slot:[`item.order_entry_id`]="{ item: detail }">
                                  <v-btn x-small text color="primary" class="font-weight-bold"
                                    @click="viewReception(data_invoice.order_id, detail.order_entry_id)">
                                    {{ detail.order_entry_id }}
                                  </v-btn>
                                </template>
                                <template v-slot:[`item.date_reception`]="{ item: detail }">
                                  {{ detail.date_reception ? getDate(detail.date_reception, 1) : "-" }}
                                </template>
                                <template v-slot:[`item.total_amount`]="{ item: detail }">
                                  <span class="font-weight-bold">{{ currencyFormat(detail.total_amount) }}</span>
                                </template>
                              </v-data-table>
                            </v-col>
                            <v-col cols="12" md="4">
                              <div class="pa-3 grey lighten-5 font-weight-bold text-caption border-bottom">AFECTACIÓN
                                CONTABLE</div>
                              <v-list dense class="pa-0">
                                <v-list-item v-for="(acc, aidx) in item.details[0]?.invoice_chart_of_accounts"
                                  :key="aidx" class="px-3 border-bottom min-h-0">
                                  <v-list-item-content class="py-1">
                                    <v-list-item-title class="text-caption font-weight-bold">
                                      {{ acc.chart_of_account_name }}
                                      <v-chip x-small outlined :color="acc.entry_type_id === 1 ? 'success' : 'info'"
                                        class="float-right">
                                        {{ acc.entry_type_name }}
                                      </v-chip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="text-caption primary--text font-weight-black">
                                      {{ currencyFormat(acc.amount) }} {{ data_invoice.currency_code }}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!item.details[0]?.invoice_chart_of_accounts?.length">
                                  <v-list-item-content class="text-caption grey--text italic text-center py-4">
                                    No hay registros contables directos
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-col>
                            <v-col cols="12" class="border-top pa-3 grey lighten-5 d-flex align-center" v-if="item.note">
                              <v-icon small color="primary" class="mr-2">mdi-note-text-outline</v-icon>
                              <span class="text-overline font-weight-bold grey--text mr-2">Nota:</span>
                              <span class="text-body-2 font-weight-black primary--text">{{ item.note }}</span>
                            </v-col>
                          </v-row>
                        </v-card>
                      </td>
                    </template>

                    <template v-slot:footer>
                      <v-row class="mt-8 px-4 px-md-10 mb-10" justify="space-between" align="end">
                        <v-col cols="12" md="6" class="mb-6 mb-md-0">
                          <div class="signature-box elaborated">
                            <v-divider class="mb-2"></v-divider>
                            <span class="text-overline font-weight-black d-block mb-1">Elaborado por</span>
                            <div class="d-flex align-center">
                              <v-avatar size="32" color="grey lighten-2" class="mr-2">
                                <span class="text-caption font-weight-bold">{{ getInitials(data_invoice.user_fullname)
                                }}</span>
                              </v-avatar>
                              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4">{{
                                data_invoice.user_fullname }}</span>
                            </div>
                          </div>

                          <div v-if="data_invoice.note"
                            class="mt-10 note-section grey lighten-5 pa-4 rounded-lg border">
                            <span class="text-overline font-weight-black d-block mb-1 grey--text">Notas /
                              Comentarios</span>
                            <p class="text-body-2 mb-0 grey--text text--darken-2 italic">{{ data_invoice.note }}</p>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4" class="ml-auto">
                          <div class="d-flex justify-space-between mb-2">
                            <span class="text-body-2 grey--text font-weight-medium">Subtotal:</span>
                            <span class="text-body-2 font-weight-black grey--text text--darken-4">
                              {{ data_invoice.currency_code }} {{ currencyFormat(data_invoice.subtotal_amount) }}
                            </span>
                          </div>
                          <div class="d-flex justify-space-between mb-2" v-if="data_invoice.discount_amount > 0">
                            <span class="text-body-2 grey--text font-weight-medium">Descuento:</span>
                            <span class="text-body-2 font-weight-black error--text">
                              {{ data_invoice.currency_code }} -{{ currencyFormat(data_invoice.discount_amount) }}
                            </span>
                          </div>
                          <div class="d-flex justify-space-between mb-3">
                            <span class="text-body-2 grey--text font-weight-medium">ITBIS:</span>
                            <span class="text-body-2 font-weight-black grey--text text--darken-4">
                              {{ data_invoice.currency_code }} {{ currencyFormat(data_invoice.taxes_amount) }}
                            </span>
                          </div>
                          <div class="d-flex justify-space-between mb-3" v-if="totalWithholdingsFromDetails > 0">
                            <span class="text-body-2 grey--text font-weight-medium">Retenciones:</span>
                            <span class="text-body-2 font-weight-black warning--text">
                              {{ data_invoice.currency_code }} -{{ currencyFormat(totalWithholdingsFromDetails) }}
                            </span>
                          </div>

                          <v-divider class="mb-4"></v-divider>

                          <div class="text-right mb-1">
                            <span class="text-overline grey--text font-weight-black letter-spacing-1">{{
                              data_invoice.currency_name?.toUpperCase() }}</span>
                          </div>

                          <div class="d-flex align-end justify-end">
                            <span class="text-h5 text-md-h3 font-weight-black primary--text mr-2">Total</span>
                            <div class="d-flex flex-column align-end">
                              <span class="text-subtitle-2 font-weight-bold grey--text line-height-1 mb-1">{{
                                data_invoice.currency_code }}</span>
                              <span class="text-h5 text-md-h3 font-weight-black primary--text line-height-1">{{
                                currencyFormat(data_invoice.total_amount) }}</span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </v-row>


          <v-row v-if="data_invoice?.invoice_type_id != 6" class="mt-8" no-gutters justify="center">
            <v-col cols="12">
              <v-card class="rounded-xl overflow-hidden border">
                <v-tabs v-model="tab" background-color="white" color="primary" show-arrows class="modern-tabs">
                  <v-tab v-for="(item, i) in itemsTab" :key="i" class="px-2 px-sm-4 px-md-6 text-capitalize font-weight-bold">
                    <v-icon left small class="mr-2">{{ item.icon }}</v-icon>
                    {{ item.title }}
                    <v-chip x-small class="ml-2 font-weight-black" color="primary lighten-5" text-color="primary"
                      v-if="item.count > 0">
                      {{ item.count }}
                    </v-chip>
                  </v-tab>
                </v-tabs>

                <v-divider></v-divider>

                <v-tabs-items v-model="tab" class="pa-2 pa-sm-4 pa-md-6">
                  <v-tab-item v-for="(tabItem, idx) in itemsTab" :key="tabItem.key">

                    <!-- TAB: PAYMENTS -->
                    <div v-if="tabItem.key === 'payments'">
                      <div v-if="paymentsInvoice && paymentsInvoice.length > 0">
                        <div class="overflow-x-auto">
                        <v-simple-table class="modern-inner-table">
                          <thead>
                            <tr>
                              <th class="text-left font-weight-black">No. PAGO</th>
                              <th class="text-left font-weight-black">FECHA</th>
                              <th class="text-left font-weight-black">MÉTODO</th>
                              <th class="text-right font-weight-black">MONTO</th>
                              <th class="text-center font-weight-black">CONTABILIDAD</th>
                              <th class="text-center font-weight-black">ESTADO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in paymentsInvoice" :key="item.invoice_payment_id">
                              <td>
                                <span
                                  @click="showPayments(item.invoice_payment_id, [2, 3].includes(data_invoice?.invoice_type_id) ? 1 : 2)"
                                  class="primary--text font-weight-black cursor-pointer hover-underline">
                                  {{ filLeft(item.invoice_payment_id.toString(), 12, "0") }}
                                </span>
                              </td>
                              <td class="grey--text text--darken-2">{{ getDate(item.payment_date, 1) }}</td>
                              <td>
                                <div class="d-flex align-center">
                                  <v-icon small color="primary" class="mr-2">{{ getIconPayments(item.payment_type_id)
                                    }}</v-icon>
                                  <span class="text-caption font-weight-bold">{{ item.payment_type_name }}</span>
                                </div>
                              </td>
                              <td class="text-right font-weight-black">
                                {{ currencyFormat(item.payment_amount) }} {{ data_invoice.currency_code }}
                              </td>
                              <td class="text-center">
                                <v-chip x-small :color="item.recorded ? 'success' : 'warning'" outlined label
                                  class="font-weight-bold">
                                  {{ item.recorded ? 'CONTABILIZADO' : 'PENDIENTE' }}
                                </v-chip>
                              </td>
                              <td class="text-center">
                                <v-chip x-small :color="item.status_id == 4 ? 'error' : 'success'" dark
                                  class="font-weight-black">
                                  {{ item.status_name.toUpperCase() }}
                                </v-chip>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot class="grey lighten-5">
                            <tr>
                              <td colspan="3" class="text-right font-weight-black">TOTAL PAGADO</td>
                              <td class="text-right primary--text font-weight-black">
                                {{currencyFormat(paymentsInvoice.filter(i => i.status_id != 4).reduce((t, i) => t + parseFloat(i.payment_amount), 0))
                                }} {{
                                  data_invoice.currency_code }}
                              </td>
                              <td colspan="2"></td>
                            </tr>
                          </tfoot>
                        </v-simple-table>
                        </div>
                        <div v-if="totals_invoices.pending_amount > 0 && can_do_payment" class="mt-6 text-right">
                          <v-btn depressed color="primary" class="rounded-lg text-capitalize"
                            @click="set_payment = true">
                            <v-icon left>mdi-plus</v-icon> Registrar Pago
                          </v-btn>
                        </div>
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-cash-off</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">No se han registrado pagos para esta factura
                        </p>
                        <v-btn v-if="totals_invoices.pending_amount > 0 && can_do_payment" outlined color="primary"
                          class="mt-2 text-capitalize rounded-lg" @click="set_payment = true">
                          Registrar Primer Pago
                        </v-btn>
                      </div>
                    </div>

                    <!-- TAB: ACCOUNTING -->
                    <div v-else-if="tabItem.key === 'accounting'">
                      <div v-if="accounting && accounting.length > 0">
                        <PostAccounting :cant_edit="can_edit_accounting" :search_names="true"
                          :order_item_entries="post_accounting_computed"
                          :total_amount="parseFloat(data_invoice?.total_amount || 0)"
                          :total_amount_base="`${accounting[0]?.business_unit_currency_code}$${currencyFormat(parseFloat(data_invoice?.total_amount) * parseFloat(accounting[0]?.currency_rate) || 0)}`"
                          :totalAmountBase="parseFloat(data_invoice?.total_amount) * (parseFloat(accounting[0]?.currency_rate)||1)"
                          :show_credits="true" :accounting_date="data_invoice?.account_date"
                          :business_unit_id="data_invoice.business_unit_id"
                          :diary_book_code="accounting[0]?.diary_book_code || 'N/A'"
                          @set_accounts="save_acounting_invoice" />
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-2">mdi-book-remove</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">La factura no ha sido contabilizada aún</p>
                      </div>
                    </div>

                    <!-- TAB: INVENTORY -->
                    <div v-else-if="tabItem.key === 'inventory'">
                      <div v-if="warehouse_details && warehouse_details.length > 0">
                        <v-data-table :headers="headersInventario" :items="warehouse_details" :items-per-page="10"
                          class="modern-inner-table" :footer-props="{
                            'items-per-page-options': [10, 25, 50, 100, -1],
                            'items-per-page-text': 'Movimientos por página:'
                          }">
                          <template v-slot:[`item.item_name`]="{ item }">
                            <div class="d-flex align-center">
                              <v-icon small class="mr-2" :color="item.entry_type_id === 1 ? 'error' : 'success'">
                                {{ item.entry_type_id === 1 ? 'mdi-minus-box' : 'mdi-plus-box' }}
                              </v-icon>
                              <span class="font-weight-bold">{{ item.item_name }}</span>
                            </div>
                          </template>
                          <template v-slot:[`item.quantity`]="{ item }">
                            <span :class="parseFloat(item.quantity) < 0 ? 'error--text' : 'success--text'"
                              class="font-weight-black">
                              {{ item.quantity }}
                            </span>
                          </template>
                          <template v-slot:[`item.effective_date`]="{ item }">
                            <span class="grey--text">{{ getDate(item.effective_date, 1) }}</span>
                          </template>
                        </v-data-table>
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-warehouse-off</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">Sin movimientos de inventario asociados</p>
                      </div>
                    </div>

                    <!-- TAB: VOUCHERS -->
                    <div v-else-if="tabItem.key === 'vouchers'">
                      <div v-if="invoice_groups && invoice_groups.length > 0">
                        <v-row class="mb-4">
                          <v-col cols="12" md="6">
                            <v-text-field v-model="searchVouchers" prepend-inner-icon="mdi-magnify"
                              label="Buscar voucher" placeholder="Buscar por número de factura, cliente, etc." outlined
                              dense hide-details clearable class="rounded-lg"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" class="text-right">
                            <v-chip color="primary" outlined class="font-weight-bold">
                              <v-icon left small>mdi-ticket-percent</v-icon>
                              Total: {{ invoice_groups.length }} vouchers
                            </v-chip>
                          </v-col>
                        </v-row>
                        <v-data-table :headers="headersInvoice" :items="invoice_groups" :search="searchVouchers"
                          :items-per-page="15" class="modern-inner-table elevation-1" :footer-props="{
                            'items-per-page-options': [10, 15, 25, 50, 100, -1],
                            'items-per-page-text': 'Vouchers por página:'
                          }">
                          <template v-slot:[`item.invoice_number`]="{ item }">
                            <span @click="showInvoice(item.invoice_id, true)"
                              class="primary--text font-weight-black cursor-pointer hover-underline">
                              {{ item.invoice_number }}
                            </span>
                          </template>
                          <template v-slot:[`item.total_amount`]="{ item }">
                            <span class="font-weight-black">{{ currencyFormat(item.total_amount) }} {{
                              item.currency_code }}</span>
                          </template>
                          <template v-slot:no-results>
                            <div class="text-center py-8">
                              <v-icon size="48" color="grey lighten-2">mdi-magnify-close</v-icon>
                              <p class="text-body-1 grey--text mt-2">No se encontraron vouchers con "{{ searchVouchers
                              }}"</p>
                            </div>
                          </template>
                        </v-data-table>
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-ticket-off</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">No se han generado vouchers vinculados</p>
                      </div>
                    </div>

                    <!-- TAB: RECEPTIONS -->
                    <div v-else-if="tabItem.key === 'receptions'">
                      <div v-if="data_entry_order && data_entry_order.length > 0">
                        <v-data-table :headers="headerReceptions" :items="data_entry_order" class="modern-inner-table">
                          <template v-slot:[`item.id`]="{ item }">
                            <span @click="viewReception(data_invoice?.order_id, item.entry_id)"
                              class="primary--text font-weight-black cursor-pointer hover-underline">
                              {{ filLeft(item.entry_id.toString(), 12, "0") }}
                            </span>
                          </template>
                          <template v-slot:[`item.created_date`]="{ item }">
                            <span class="grey--text">{{ getDate(item.created_date, 1) }}</span>
                          </template>
                        </v-data-table>
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-package-variant-closed-remove</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">No se han registrado recepciones físicas</p>
                      </div>
                    </div>

                    <!-- TAB: CREDITS/DEBITS -->
                    <div v-else-if="['credits', 'debits'].includes(tabItem.key)">
                      <div v-if="tabItem.key === 'credits' && note_credits && note_credits.length > 0">
                        <v-data-table :headers="headersInvoice" :items="note_credits" class="modern-inner-table"
                          hide-default-footer>
                          <template v-slot:[`item.invoice_number`]="{ item }">
                            <span @click="showNote(item.id, true)"
                              class="primary--text font-weight-black cursor-pointer hover-underline">
                              {{ item.id }}
                            </span>
                          </template>
                          <template v-slot:[`item.total_amount`]="{ item }">
                            <span class="orange--text font-weight-black">{{ currencyFormat(item.total_amount) }} {{
                              item.currency_code }}</span>
                          </template>
                        </v-data-table>
                      </div>
                      <div v-else-if="tabItem.key === 'debits' && note_debits && note_debits.length > 0">
                        <v-data-table :headers="headersInvoice" :items="note_debits" class="modern-inner-table"
                          hide-default-footer>
                          <template v-slot:[`item.invoice_number`]="{ item }">
                            <span @click="showNote(item.id, true)"
                              class="primary--text font-weight-black cursor-pointer hover-underline">
                              {{ item.id }}
                            </span>
                          </template>
                          <template v-slot:[`item.total_amount`]="{ item }">
                            <span class="primary--text font-weight-black">{{ currencyFormat(item.total_amount) }} {{
                              item.currency_code }}</span>
                          </template>
                        </v-data-table>
                      </div>
                      <div v-else class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-file-remove-outline</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">No existen notas de {{ tabItem.key ===
                          'credits' ?
                          'crédito' : 'débito' }}</p>
                      </div>
                    </div>

                    <!-- TAB: WITHHOLDINGS -->
                    <div v-else-if="tabItem.key === 'withholdings'">
                      <!-- Line-item withholdings from invoice details -->
                      <div v-if="lineItemWithholdings.length > 0">
                        <div class="text-overline font-weight-black grey--text mb-3">Retenciones por artículo</div>
                        <div class="overflow-x-auto">
                        <v-simple-table class="modern-inner-table mb-6">
                          <thead>
                            <tr>
                              <th class="text-left font-weight-black">ARTÍCULO</th>
                              <th class="text-left font-weight-black">TIPO RETENCIÓN</th>
                              <th class="text-right font-weight-black">MONTO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(d, didx) in lineItemWithholdings" :key="didx">
                              <td class="font-weight-bold">{{ d.item_description || d.item_name }}</td>
                              <td>
                                <v-chip x-small color="orange lighten-5" text-color="orange darken-4" class="font-weight-black">
                                  {{ d.withholding_name }}
                                </v-chip>
                              </td>
                              <td class="text-right font-weight-black warning--text">
                                {{ currencyFormat(d.withholding_amount) }} {{ data_invoice.currency_code }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot class="grey lighten-5">
                            <tr>
                              <td colspan="2" class="text-right font-weight-black">TOTAL RETENIDO</td>
                              <td class="text-right warning--text font-weight-black">
                                {{ currencyFormat(totalWithholdingsFromDetails) }} {{ data_invoice.currency_code }}
                              </td>
                            </tr>
                          </tfoot>
                        </v-simple-table>
                        </div>
                      </div>
                      <!-- Invoice-level withholdings -->
                      <div v-if="data_invoice.withholdings && data_invoice.withholdings.length > 0">
                        <div class="text-overline font-weight-black grey--text mb-3">Retenciones fiscales registradas</div>
                        <div class="overflow-x-auto">
                        <v-simple-table class="modern-inner-table">
                          <thead>
                            <tr>
                              <th class="text-left font-weight-black">TIPO</th>
                              <th class="text-left font-weight-black">REFERENCIA</th>
                              <th class="text-left font-weight-black">FECHA</th>
                              <th class="text-right font-weight-black">MÉTODO</th>
                              <th class="text-right font-weight-black">MONTO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(w, widx) in data_invoice.withholdings" :key="widx">
                              <td>
                                <v-chip x-small color="orange lighten-5" text-color="orange darken-4" class="font-weight-black">
                                  {{ w.withholding_type_name }}
                                </v-chip>
                              </td>
                              <td class="font-weight-bold">{{ w.reference_number || 'N/A' }}</td>
                              <td class="grey--text">{{ getDate(w.created_at, 1) }}</td>
                              <td class="text-right">{{ w.payment_type_name }}</td>
                              <td class="text-right font-weight-black">{{ currencyFormat(w.amount) }} {{ data_invoice.currency_code }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                        </div>
                      </div>
                      <!-- Empty state -->
                      <div v-if="!lineItemWithholdings.length && !(data_invoice.withholdings && data_invoice.withholdings.length > 0)" class="text-center py-12">
                        <v-icon size="64" color="grey lighten-3">mdi-percent-outline</v-icon>
                        <p class="text-h6 grey--text text--lighten-1 mt-4">No se han registrado retenciones fiscales</p>
                      </div>
                    </div>

                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-12" no-gutters>
            <v-col cols="12" md="4">
              <v-card flat class="rounded-xl pa-6 border" height="100%">
                <div class="d-flex align-center mb-4">
                  <v-icon color="primary" class="mr-2">mdi-history</v-icon>
                  <span class="text-overline font-weight-black">Registro del Sistema</span>
                </div>
                <div class="d-flex flex-column">
                  <div class="mb-3">
                    <span class="text-caption grey--text d-block">Fecha Creacion</span>
                    <span class="text-body-2 font-weight-bold">{{ getDate(data_invoice.created_date, 1) }}</span>
                  </div>
                  <div class="mb-3">
                    <span class="text-caption grey--text d-block">Fecha Efectiva</span>
                    <span class="text-body-2 font-weight-bold">{{ getDate(data_invoice.emission_date, 1) }}</span>
                  </div>
                  <div v-if="data_invoice.account_date" class="mb-3">
                    <span class="text-caption grey--text d-block">Fecha Contable</span>
                    <span class="text-body-2 font-weight-bold">{{ getDate(data_invoice.account_date, 1) }}</span>
                  </div>
                  <div class="mb-3">
                    <span class="text-caption grey--text d-block">Vencimiento</span>
                    <span class="text-body-2 font-weight-bold" :class="isExpired ? 'error--text pulse-active' : ''">
                      {{ getDate(data_invoice.expire_at, 1) }}
                    </span>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="d-flex align-center">
                    <v-avatar size="24" color="grey lighten-4" class="mr-2">
                      <v-icon x-small color="grey">mdi-account</v-icon>
                    </v-avatar>
                    <span class="text-caption grey--text">Registrado por <b>{{ data_invoice.user_fullname }}</b></span>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="8" class="pl-md-6 mt-6 mt-md-0">
              <v-card flat class="rounded-xl pa-6 border" height="100%">
                <div class="d-flex align-center justify-space-between mb-4">
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-attachment</v-icon>
                    <span class="text-overline font-weight-black">Archivos Adjuntos</span>
                    <v-chip v-if="itemsFiles && itemsFiles.length > 0" x-small class="ml-2" color="primary lighten-5"
                      text-color="primary">
                      {{ itemsFiles.length }}
                    </v-chip>
                  </div>
                  <v-btn v-if="hasFeature('SHOP-163') || hasFeature('ING-025')" small text color="primary" class="text-capitalize font-weight-bold" @click="takeImage">
                    <v-icon left small>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>

                <div v-if="itemsFiles && itemsFiles.length > 0">
                  <v-list class="pa-0">
                    <v-list-item v-for="(file, fidx) in itemsFiles" :key="fidx" class="px-0 py-1">
                      <v-list-item-avatar tile size="40" class="rounded-lg grey lighten-5 border">
                        <v-icon color="grey darken-1">mdi-file-document-outline</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2 font-weight-bold truncate">
                          {{ file.description || 'Sin descripción' }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-caption grey--text">
                          Documento adjunto el {{ getDate(file.created_date, 1) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action class="d-flex flex-row align-center" style="gap:4px">
                        <v-btn icon small @click="viewAddtached(file)">
                          <v-icon small color="primary">mdi-eye-outline</v-icon>
                        </v-btn>
                        <v-btn icon small @click="confirmDeleteFile(file, fidx)">
                          <v-icon small color="error">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>
                <div v-else
                  class="d-flex flex-column align-center justify-center py-8 grey lighten-5 rounded-xl border-dashed">
                  <v-icon color="grey lighten-1 " size="48">mdi-cloud-upload-outline</v-icon>
                  <span class="text-caption grey--text mt-2 italic">No hay archivos vinculados</span>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-file-input v-show="false" style="opacity: 0" name="upload" id="fileInput"
            @change="onFileChange"></v-file-input>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-row justify="center">
        <v-col cols="12" md="10">
          <v-container fluid>
            <!-- Header skeleton -->
            <v-row no-gutters class="mb-3">
              <v-skeleton-loader type="heading" width="300" class="mb-2"></v-skeleton-loader>
            </v-row>

            <!-- Action buttons skeleton -->
            <v-row no-gutters class="mb-3">
              <v-skeleton-loader type="button" width="100" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" width="100" class="mr-2"></v-skeleton-loader>
              <v-skeleton-loader type="button" width="120" class="mr-2"></v-skeleton-loader>
            </v-row>

            <!-- Alert skeleton (for DGII warning) -->
            <v-row no-gutters class="mb-4">
              <v-col cols="12">
                <v-skeleton-loader type="card" height="120"></v-skeleton-loader>
              </v-col>
            </v-row>

            <!-- Totals card skeleton -->
            <v-row no-gutters class="mb-4">
              <v-col cols="12">
                <v-skeleton-loader type="card" height="100"></v-skeleton-loader>
              </v-col>
            </v-row>

            <!-- Invoice details skeleton -->
            <v-row no-gutters class="mt-4">
              <v-col cols="12">
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="4">
                        <v-skeleton-loader type="avatar" class="mb-2"></v-skeleton-loader>
                        <v-skeleton-loader type="text" width="150"></v-skeleton-loader>
                      </v-col>
                      <v-col cols="4">
                        <v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                      </v-col>
                      <v-col cols="4">
                        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                      </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                      <v-col cols="6">
                        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
                      </v-col>
                      <v-col cols="6">
                        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
                        <v-skeleton-loader type="text" class="mb-2"></v-skeleton-loader>
                      </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <!-- Table skeleton -->
                    <v-skeleton-loader type="table-thead, table-tbody" class="my-4"></v-skeleton-loader>
                    <!-- Totals skeleton -->
                    <v-row justify="end" class="mt-4">
                      <v-col cols="4">
                        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Tabs skeleton -->
            <v-row no-gutters class="mt-4">
              <v-col cols="12">
                <v-skeleton-loader type="card" height="300"></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-row>
    <v-dialog v-model="dialogCampos" max-width="500" v-if="dialogCampos">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <v-spacer></v-spacer>
          Campos adicionales
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center" class="mt-4">
            <v-col cols="10">
              <v-text-field v-model="inputs_to_update.supplier_invoice_number" label="Factura suplidor" color="cyanText"
                outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="10">
              <v-text-field v-model="inputs_to_update.supplier_invoice_voucher" label="Comprobante suplidor"
                color="cyanText" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col md="10">
              <v-menu v-model="menu_accounting_date" :close-on-content-click="false" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="set_accounting_date_computed" label="Fecha contable"
                    prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined
                    hide-details="auto" class="mt-2"></v-text-field>
                </template>
                <v-date-picker :min="dates_accounting?.start_date" :max="dates_accounting.end_date"
                  v-model="inputs_to_update.set_accounting_date"
                  @input="(menu_accounting_date = false)"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="dialogCampos = false">Cancelar</v-btn>
          <v-btn color="primary" outlined @click="saveCampos">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAttached" height="70vh" max-width="900">
      <div style="
          position: relative;
          padding-bottom: 56.25%; /* 16:9 */
          padding-top: 25px;
          height: 0;
        ">
        <iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 69vh" :src="selectedAttached"
          frameborder="0" title="Archivo adjunto"></iframe>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogCancelInvoice" transition="dialog-top-transition" max-width="600">
      <v-card>
        <v-toolbar color="primary" dark>Anular factura</v-toolbar>
        <v-card-text class="text-center">
          <div class="text-h5 pa-5 text-center">
            Seguro que deseas eliminar esta factura?
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="dialogCancelInvoice = false">Volver</v-btn>
          <v-btn outlined @click="cancelInvoice">Anular factura</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAccountingInvoice" transition="dialog-top-transition" max-width="600">
      <v-card>
        <v-toolbar color="primary" dark>Contabilizar</v-toolbar>
        <v-card-text class="text-center">
          <div class="text-h5 pa-5 text-center">
            Seguro que deseas contabilizar esta factura?
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="dialogAccountingInvoice = false">Volver</v-btn>
          <v-btn color="primary" outlined @click="accountingInvoice" :loading="loading_accounting">Contabilizar
            factura</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancelAccountingInvoice" transition="dialog-top-transition" max-width="600">
      <v-card>
        <v-toolbar color="primary" dark>Contabilizar</v-toolbar>
        <v-card-text class="text-center">
          <div class="text-h5 pa-5 text-center">
            Seguro que deseas anular la contabilidad de esta factura?
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="dialogCancelAccountingInvoice = false">Volver</v-btn>
          <v-btn color="primary" outlined @click="cancelAccountingInvoice" :loading="loading_accounting">descontabilizar
            factura</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteFile" transition="dialog-top-transition" max-width="420">
      <v-card>
        <v-toolbar color="error" dark dense>
          <v-icon class="mr-2">mdi-trash-can-outline</v-icon>
          Eliminar archivo adjunto
        </v-toolbar>
        <v-card-text class="text-center pt-6">
          <div class="text-body-1">
            ¿Seguro que deseas eliminar
            <b>{{ fileToDelete ? (fileToDelete.description || fileToDelete.name) : '' }}</b>?
          </div>
          <div class="text-caption grey--text mt-1">Esta acción no se puede deshacer.</div>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn text @click="dialogDeleteFile = false">Cancelar</v-btn>
          <v-btn color="error" outlined :loading="loadingDeleteFile" @click="deleteFile">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="set_payment" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="set_payment = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Realizar pago</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="set_payment = false">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <CheckOutCxC :data="data_to_pay" :type="data_invoice?.invoice_type_id"
              @close="getData(), (set_payment = false)" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<style scoped>
.dgii-response {
  font-size: 0.875rem;
}

.dgii-raw {
  max-height: 300px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.75rem;
  background: rgba(0, 0, 0, 0.04);
  padding: 8px;
  border-radius: 6px;
}

.folded-paper:before {
  content: "";
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  position: absolute;
  top: 0;
  right: 0;
  border-width: 0 30px 30px 0;
  border-style: solid;
  border-color: rgb(74, 92, 67) #fff;
  transition: 0.3s;
  border-radius: 0 0 0 4px;
}

.box {
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);
}

.width-label {
  min-width: 110px;
  display: inline-block;
}

.border-right-light {
  border-right: 1px solid #f1f5f9;
}

.ncf-hero-bar {
  background: linear-gradient(to right, #ffffff, #f8fafc);
  border: 1px solid #e2e8f0 !important;
}

.ncf-accent-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: var(--v-primary-base);
  opacity: 0.1;
}

.line-height-1 {
  line-height: 1 !important;
}

.uppercase {
  text-transform: uppercase;
}

.folded_corner {
  position: relative;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: linear-gradient(to left bottom, transparent 50%, rgba(0, 0, 0, 0.05) 0) no-repeat 100% 0 / 2em 2em,
    linear-gradient(-135deg, transparent 1.5em, white 0);
}

.folded_corner::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 40px 40px 0;
  border-color: transparent transparent rgba(0, 0, 0, 0.05) transparent;
  pointer-events: none;
}

/* Expert UI Style Tokens */
.summary-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05) !important;
}

.card-total {
  background: linear-gradient(135deg, #f0f4ff, #ffffff) !important;
}

.card-withheld {
  background: linear-gradient(135deg, #fff5f5, #ffffff) !important;
}

.card-credits {
  background: linear-gradient(135deg, #fff9f0, #ffffff) !important;
}

.card-paid {
  background: linear-gradient(135deg, #f0fff4, #ffffff) !important;
}

.card-pending {
  background: linear-gradient(135deg, #fff0f0, #ffffff) !important;
}

.ncf-box {
  background: #f8fafc;
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  display: inline-block;
}

.custom-table {
  background-color: transparent !important;
}

.custom-table th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #5c6bc0 !important;
}

.expanded-row-bg {
  background-color: #fcfdfe !important;
}

.inner-table {
  background-color: white !important;
}

.inner-table th {
  font-size: 10px !important;
  color: #94a3b8 !important;
}

.status-stamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-30deg);
  font-size: 80px;
  font-weight: 900;
  opacity: 0.1;
  pointer-events: none;
  z-index: 0;
  border: 15px solid;
  padding: 10px 40px;
  border-radius: 20px;
  white-space: nowrap;
}

.status-stamp.closed {
  color: #2e7d32;
  border-color: #2e7d32;
}

.status-stamp.cancelled {
  color: #c62828;
  border-color: #c62828;
}

.hover-underline:hover {
  text-decoration: underline !important;
}

.expiry-box {
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #991b1b;
}

.totals-display {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.line-height-1 {
  line-height: 1 !important;
}

.italic {
  font-style: italic;
}

.containerIframe {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.glow-text {
  text-shadow: 0 0 15px rgba(var(--v-primary-base), 0.2);
}

.category-indicator {
  display: inline-flex;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}

.letter-spacing-2 {
  letter-spacing: 2px !important;
}

.border-left-soft {
  border-left: 1px solid #edf2f7;
}

.border-primary-light {
  border: 1px solid rgba(var(--v-primary-base), 0.1) !important;
}

.border-left-primary {
  border-left: 4px solid #ffc107 !important;
  /* Emulating the yellow from the screenshot */
}

.animate__animated {
  animation-duration: 0.6s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate__fadeIn {
  animation-name: fadeIn;
}

.summary-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #f1f5f9 !important;
  position: relative;
  overflow: hidden;
}

.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.08), 0 10px 15px -10px rgba(0, 0, 0, 0.05) !important;
}

.summary-card::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, transparent 50%, rgba(255, 255, 255, 0.4) 100%);
  pointer-events: none;
}

.copy-invoice-number {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.copy-invoice-number .copy-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.copy-invoice-number:hover .copy-icon {
  opacity: 0.7;
}

.copy-invoice-number:hover {
  opacity: 0.85;
}

.summary-card-title {
  font-size: 0.65rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.55);
}

.gap-2 {
  gap: 8px;
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.header-meta-row {
  background: #f8fafc;
  padding: 8px 20px;
  border-radius: 12px;
  border: 1px solid #edf2f7;
  box-shadow: inset 0 1px 2px rgba(60, 64, 67, 0.05);
}

.production-metadata-bar {
  background-color: #f8fafc;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.meta-item {
  position: relative;
}

.gap-6 {
  gap: 24px;
}

.border-left {
  border-left: 4px solid var(--v-primary-base);
}

.signature-box {
  padding-top: 2rem;
  max-width: 300px;
}

.signature-box.elaborated {
  border-top: none;
}

.totals-display {
  background: #f8fafc !important;
  border: 1px solid #edf2f7 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.note-section {
  background-color: #f8fafc !important;
  border: 1px dashed #cbd5e1 !important;
  position: relative;
}

.note-section::before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #cbd5e1;
  border-radius: 4px 0 0 4px;
}

.modern-tabs .v-tab--active {
  background: rgba(var(--v-primary-base), 0.05);
  border-bottom: 2px solid var(--v-primary-base);
}

.modern-inner-table.v-data-table {
  background: transparent !important;
}

.modern-inner-table.v-data-table thead th {
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.05em;
  color: #7f8c8d !important;
  border-bottom: 1px solid #edf2f7 !important;
}

.modern-inner-table.v-data-table tbody td {
  font-size: 0.875rem !important;
  padding: 1rem !important;
  border-bottom: 1px solid #f8fafc !important;
}

.modern-inner-table.v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-underline:hover {
  text-decoration: underline;
}

.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.min-h-0 {
  min-height: 0 !important;
}

.line-height-1 {
  line-height: 1;
}

.border-dashed {
  border: 2px dashed #edf2f7 !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-total {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, #ffffff 100%);
}

.card-withheld {
  background: linear-gradient(135deg, rgba(211, 47, 47, 0.05) 0%, #ffffff 100%);
}

.card-credits {
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.05) 0%, #ffffff 100%);
}

.card-paid {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, #ffffff 100%);
}

.card-pending {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.05) 0%, #ffffff 100%);
}

@keyframes pulse-soft {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.02);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.pulse-active {
  animation: pulse-soft 2s infinite ease-in-out;
}

@media (max-width: 600px) {
  .width-label {
    min-width: 80px;
  }

  .border-right-light {
    border-right: none;
  }

  .ncf-hero-bar {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 12px;
  }

  .signature-box {
    max-width: 100%;
  }

  .modern-inner-table.v-data-table tbody td {
    padding: 0.5rem !important;
  }
}
</style>
<script>
import moment from "moment";
import ExcelJS from "exceljs";
import PostAccounting from "@/components/Accounting/PostAccounting.vue";
import CheckOutCxC from "@/components/Transactions/CheckOutCxC.vue";
export default {
  components: {
    PostAccounting,
    CheckOutCxC,
  },
  data: () => ({
    dialogCampos: false,
    hasPreviousPage: false,
    new_data_invoices: [],
    hasFiles: false,
    set_payment: false,
    data_invoices_pay: [
      {
        invoice_id: 170673,
        business_unit_id: 145,
        business_unit_description: "DOMINICAN KNITS TEXTILES",
        location_id: 403,
        created_by: 571,
        entity_id: 111764,
        entity_name: "AGUA RANGEL SRL",
        emission_date: "2025-09-05T19:53:58.000Z",
        expire_at: "2025-10-05T04:00:00.000Z",
        currency_id: 1,
        currency_code: "DOP",
        invoice_type_id: 1,
        invoice_number: "FCDKT0000000592",
        invoice_ncf: null,
        total_amount: "3280.00",
        paid: 3280,
        supplier_invoice_number: "F005542",
        total_to_pay: "3280.00",
        total_paid: "0.0000",
        pending_amount: "3280.000000",
        status_id: 1,
        invoice_category_id: 2,
        original_pending_amount: "3280.000000",
        original_total_paid: "0.0000",
        original_total_to_pay: "3280.00",
        original_currency_code: "DOP",
        original_currency_id: 1,
        paid_base_usd: 3280,
        send_missing: false,
        missing_amount: 0,
      },
    ],
    dialogCancelInvoice: false,
    dialogAccountingInvoice: false,
    dialogCancelAccountingInvoice: false,
    loading_accounting: false,
    search: "",
    searchVouchers: "",
    loading: false,
    selectedAttached: "",
    loadingAttachment: false,
    dialogAttached: false,
    dialogDeleteFile: false,
    fileToDelete: null,
    fileToDeleteIndex: null,
    loadingDeleteFile: false,
    date: moment().startOf("month").format("YYYY-MM-DD"),
    date2: moment().startOf("month").format("YYYY-MM-DD"),
    id_invoice: null,
    storage_invoice: "",
    totals_invoices: {
      pending_amount: 0,
      total_paid: 0,
      total_credits: 0,
      total_debits: 0,
      total_withholdings: 0,
    },
    data_invoice: null,
    detailsItems: [],
    tab: null,
    accounting: [],
    invoice_details: [],
    paymentsInvoice: [],
    invoice_groups: [],
    warehouse_details: [],
    locationImage: null,
    storage_json: [],
    expanded: [],
    data_entry_order: [],
    headerReceptions: [
      {
        text: "Recepcion",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Almacen", value: "warehouses_name" },
      { text: "Fecha", value: "created_date", align: "start" },
      { text: "Usuario", value: "user_fullname", align: "start" },
      { text: "", value: "actions", align: "end" },
    ],
    headersContabilidad: [
      { text: "Asiento", align: "start", sortable: false, value: "diary_book_code" },
      { text: "Cuenta", value: "chart_of_account_name" },
      { text: "Location", value: "location_description" },
      { text: "Ent.", value: "entity_name" },
      { text: "Cat.", value: "category_name" },
      { text: "Sub Cat.", value: "subcategory_name" },
      { text: "Déb trans", value: "debito", align: "right" },
      { text: "Cré trans", value: "credito", align: "right" },
      { text: "Débito", value: "debitoBase", align: "right" },
      { text: "Crédito", value: "creditoBase", align: "right" },
    ],
    headersInvoice: [
      {
        text: "Factura",
        align: "start",
        sortable: false,
        value: "invoice_number",
      },
      { text: "Código", value: "employee_code" },
      { text: "Cliente", value: "entity_name" },
      { text: "Fecha", value: "emission_date" },
      { text: "	Monto", value: "total_amount", align: "right" },
    ],
    headersInventario: [
      { text: "	Item", value: "item_name" },

      { text: "Cantidad", value: "quantity" },
      { text: "	Almacén", value: "warehouse_name" },

      { text: "	Tipo", value: "entry_type_name" },
      {
        text: "Fecha",
        align: "start",
        sortable: false,
        value: "effective_date",
      },
    ],

    headers: [
      { text: "", value: "data-table-expand" },
      { text: "#", value: "index", align: "start", width: "40px" },
      { text: "ID", align: "start", sortable: false, value: "item_id" },
      { text: "Producto/servicio", align: "start", sortable: false, value: "item_name" },
      { text: "Unidad", value: "unit_name", align: "center" },
      { text: "Precio", value: "price", align: "end" },
      { text: "Cant.", value: "total_quantity", align: "end" },
      { text: "Sub total", value: "sub_total", align: "end" },
      { text: "Desc.", value: "discount", align: "end" },
      { text: "ITBIS", value: "itbis", align: "end" },
      { text: "Total", value: "total", align: "end" },
    ],
    headersSubTable: [
      { text: "Order Entry ID", value: "order_entry_id", align: "start" },
      { text: "Cantidad", value: "quantity", align: "end" },
      { text: "Almacén", value: "warehouse_id", align: "end" },
      { text: "Total", value: "total_amount", align: "end" },
    ],
    note_credits: [],
    note_debits: [],
    is_valid_dgii: false,
    itemsFiles: [],
    headersFiles: [
      {
        text: "Descripcion",
        align: "start",
        sortable: false,
        value: "description",
      },

      { text: "	Action", value: "actions", align: "end" },
    ],
    commentHeader: "",
    dates_accounting: {
      start_date: null,
      end_date: null,
    },
    inputs_to_update: {
      supplier_invoice_number: null,
      supplier_invoice_voucher: null,
      set_accounting_date: null,
    },
    menu_accounting_date: false,
    is_valid_dgii: false,
    loading_dgii: false,
    dgii_status: null,
    dgii_send_result: null,
    show_dgii_raw: false,
  }),
  computed: {
    itemsTab() {
      if (!this.data_invoice) return [];

      const isSale = [2, 3].includes(this.data_invoice?.invoice_type_id);
      const data = [
        {
          title: isSale ? "Pagos Recibidos" : "Pagos Realizados",
          icon: "mdi-cash-multiple",
          key: "payments",
          count: this.paymentsInvoice?.length || 0
        },
        {
          title: "Contabilidad",
          icon: "mdi-book-open-variant",
          key: "accounting",
          count: this.accounting?.length || 0
        },
        {
          title: "Inventario",
          icon: "mdi-warehouse",
          key: "inventory",
          count: this.warehouse_details?.length || 0
        }
      ];

      if (isSale) {
        data.push({
          title: "Vouchers",
          icon: "mdi-ticket-percent",
          key: "vouchers",
          count: this.invoice_groups?.length || 0
        });
      }

      data.push({
        title: "Retenciones",
        icon: "mdi-percent",
        key: "withholdings",
        count: (this.data_invoice.withholdings?.length || 0) + this.lineItemWithholdings.length
      });

      if (this.data_invoice?.invoice_type_id == 1) {
        data.push({
          title: "Recepciones",
          icon: "mdi-package-variant-closed",
          key: "receptions",
          count: this.data_entry_order?.length || 0
        });
      }

      data.push({
        title: "Notas de Crédito",
        icon: "mdi-file-download-outline",
        key: "credits",
        count: this.note_credits?.length || 0
      });
      data.push({
        title: "Notas de Débito",
        icon: "mdi-file-upload-outline",
        key: "debits",
        count: this.note_debits?.length || 0
      });

      return data;
    },
    formTitle() {
      if (this.data_invoice?.invoice_type_id === 1) {
        return "Factura compra";
      }
      if (this.data_invoice?.invoice_type_id === 2) {
        return "Factura venta";
      }
      if (this.data_invoice?.invoice_type_id === 3) {
        return "Documento interno por cobrar";
      }
      if (this.data_invoice?.invoice_type_id === 4) {
        return "Documento interno por pagar";
      }
      if (this.data_invoice?.invoice_type_id === 5) {
        return "Voucher";
      }
      if (this.data_invoice?.invoice_type_id === 6) {
        return "Cotizacion";
      }
      if (this.data_invoice?.invoice_type_id === 7) {
        return "FACTURA PEDIDOS";
      }
      if (this.data_invoice?.invoice_type_id === 8) {
        return "FACTURA DE BONO";
      }
    },
    totalContabilidad() {
      let debito = 0;
      let credito = 0;

      if (this.accounting.length > 0) {
        for (let item of this.accounting) {
          if (item.entry_type_id == 1) {
            debito += parseFloat(item.amount);
          }
          if (item.entry_type_id == 2) {
            credito += parseFloat(item.amount);
          }
        }
      }

      return {
        debito: parseFloat(debito).toFixed(2),
        credito: parseFloat(credito).toFixed(2),
      };
    },
    entityAddress() {
      if (!this.data_invoice?.entity_contact_json) return null;
      const addr = this.data_invoice.entity_contact_json.find(c => c.id_type === 10);
      return addr ? addr.description : null;
    },
    entityShipTo() {
      if (!this.data_invoice?.entity_contact_json) return null;
      const ship = this.data_invoice.entity_contact_json.find(c => c.id_type === 16);
      return ship ? ship.description : null;
    },
    hasProductionMetadata() {
      const meta = this.data_invoice?.metadata;
      if (!meta) return false;
      return meta.color || meta.content || meta.yarnLot || meta.colorName;
    },
    groupedInvoiceDetails() {
      if (!this.invoice_details || this.invoice_details.length === 0) {
        return [];
      }

      const grouped = this.invoice_details.reduce((acc, item) => {
        const itemId = item.item_id;

        if (!acc[itemId]) {
          acc[itemId] = {
            ...item,
            total_quantity: 0,
            details: [],
            total_amount_sum: 0,
          };
        }

        acc[itemId].total_quantity += parseFloat(item.quantity);
        acc[itemId].total_amount_sum += parseFloat(item.total_amount);
        acc[itemId].details.push({
          order_entry_id: item.order_entry_id,
          quantity: item.quantity,
          warehouse_id: item.warehouse_id,
          total_amount: item.total_amount,
          date_reception: item.date_reception,
          supplier_invoice_number: item.supplier_invoice_number,
          invoice_chart_of_accounts: item.invoice_chart_of_accounts || []
        });

        return acc;
      }, {});

      return Object.values(grouped);
    },
    summaryCards() {
      if (!this.data_invoice || !this.totals_invoices) return [];
      const isPayable = [1, 4].includes(this.data_invoice?.invoice_type_id);
      return [
        {
          title: "Valor Total",
          value: this.data_invoice.total_amount,
          icon: "mdi-currency-usd",
          iconColor: "primary",
          colorClass: "card-total"
        },
        {
          title: "Retenido",
          value: this.totals_invoices.total_withholdings,
          icon: "mdi-account-off",
          iconColor: "error",
          colorClass: "card-withheld"
        },
        {
          title: "Notas de Crédito",
          value: this.totals_invoices.total_credits,
          icon: "mdi-file-undo",
          iconColor: "orange",
          colorClass: "card-credits"
        },
        {
          title: "Notas de Débito",
          value: this.totals_invoices.total_debits,
          icon: "mdi-file-plus",
          iconColor: "primary",
          colorClass: "card-total"
        },
        {
          title: isPayable ? "Pagado" : "Cobrado",
          value: this.totals_invoices.total_paid,
          icon: "mdi-cash-check",
          iconColor: "success",
          colorClass: "card-paid"
        },
        {
          title: isPayable ? "Por Pagar" : "Por Cobrar",
          value: this.totals_invoices.pending_amount,
          icon: "mdi-alert-circle",
          iconColor: "error",
          colorClass: "card-pending"
        }
      ];
    },
    totalWithholdingsFromDetails() {
      if (!this.invoice_details || !this.invoice_details.length) return 0;
      return this.invoice_details.reduce((sum, d) => sum + parseFloat(d.withholding_amount || 0), 0);
    },
    lineItemWithholdings() {
      if (!this.invoice_details || !this.invoice_details.length) return [];
      return this.invoice_details.filter(d => d.withholding_id_ref != null && parseFloat(d.withholding_amount || 0) > 0);
    },
    isExpired() {
      if (!this.data_invoice?.expire_at) return false;
      return moment(this.data_invoice.expire_at).isBefore(moment(), 'day');
    },
    post_accounting_computed() {
      return this.accounting.map((entry) => {
        return {
          order_chart_of_accounts: [
            {
              chart_of_account_id: entry.chart_of_account_id,
              chart_of_account_code: entry.chart_of_account_code,
              chart_of_account_name: entry.chart_of_account_name,
              category_id: entry.category_id,
              subcategory_id: entry.subcategory_id,
              location_id: entry.location_id,
              department_id: entry.department_id,
              entry_type_id: entry.entry_type_id,
              amount: parseFloat(entry.amount),
              currency_rate: parseFloat(entry.currency_rate),
              currency_id: entry.currency_id,
              diary_book_id: entry.diary_book_id,
              entity_id: entry.entity_id,
              entity_name: entry.entity_name,
            },
          ],
          entity_name: entry.entity_name,
          item_name: "Entrada Contable", // Valor por defecto ya que no existe en la estructura original
          currency_code: entry.currency_code,
        };
      });
    },
    can_edit_accounting() {
      // Editar la CONTABILIDAD (asiento) de la factura ya contabilizada.
      if (
        this.data_invoice?.invoice_type_id == 1 &&
        this.$store.state.auth.globalFeatures.includes("SHOP-162")
      ) {
        return true;
      }
      if (
        this.data_invoice?.invoice_type_id == 2 &&
        this.$store.state.auth.globalFeatures.includes("ING-024")
      ) {
        return true;
      }
      return false;
    },
    // Editar la factura (incluye el botón "Campos adicionales", visible aunque
    // esté contabilizada). Compra (tipo 1/4) -> SHOP-164; Venta (tipo 2) -> ING-026.
    can_edit_invoice() {
      if (
        [1, 4].includes(this.data_invoice?.invoice_type_id) &&
        this.$store.state.auth.globalFeatures.includes("SHOP-164")
      ) {
        return true;
      }
      if (
        this.data_invoice?.invoice_type_id == 2 &&
        this.$store.state.auth.globalFeatures.includes("ING-026")
      ) {
        return true;
      }
      return false;
    },
    // Descontabilizar (anular asiento).
    // Compra (tipo 1 Factura Compra, 4 Doc. Interno CxP) -> SHOP-165.
    // Venta (tipo 2 Factura Venta, 3 Doc. Interno CxC, 5 Voucher, 8 Bono) -> ING-022.
    can_descontabilizar() {
      if (
        [1, 4].includes(this.data_invoice?.invoice_type_id) &&
        this.$store.state.auth.globalFeatures.includes("SHOP-165")
      ) {
        return true;
      }
      if (
        [2, 3, 5, 8].includes(this.data_invoice?.invoice_type_id) &&
        this.$store.state.auth.globalFeatures.includes("ING-022")
      ) {
        return true;
      }
      return false;
    },
    can_do_payment() {
      // Usar los códigos de ESCRITURA (gestionar pagos), no los de vista/lectura:
      // de lo contrario un perfil de consulta (que tiene CXP-02/CXC-02 de solo VER)
      // podría registrar pagos desde la factura.
      if (
        this.data_invoice?.invoice_type_id == 1 &&
        this.$store.state.auth.globalFeatures.includes("CXP-022")
      ) {
        return true;
      }
      if (
        this.data_invoice?.invoice_type_id == 2 &&
        this.$store.state.auth.globalFeatures.includes("CXC-012")
      ) {
        return true;
      }
      return false;
    },
    data_to_pay() {
      if (this.data_invoice == null) {
        return [];
      }
      return [
        {
          invoice_id: this.data_invoice.invoice_id,
          business_unit_id: this.data_invoice.business_unit_id,
          business_unit_description: this.data_invoice.business_unit_description,
          location_id: this.data_invoice.location_id,
          created_by: this.data_invoice.created_by,
          entity_id: this.data_invoice.entity_id,
          entity_name: this.data_invoice.entity_name,
          emission_date: this.data_invoice.emission_date,
          expire_at: this.data_invoice.expire_at,
          currency_id: this.data_invoice.currency_id,
          currency_code: this.data_invoice.currency_code,
          invoice_type_id: this.data_invoice?.invoice_type_id,
          invoice_number: this.data_invoice.invoice_number,
          invoice_ncf: this.data_invoice.invoice_ncf,
          total_amount: this.data_invoice.total_amount,
          paid: this.totals_invoices.total_paid || 0,
          supplier_invoice_number: this.data_invoice.supplier_invoice_number,
          total_to_pay: this.totals_invoices.pending_amount,
          total_paid: this.totals_invoices.total_paid,
          pending_amount: this.totals_invoices.pending_amount,
          status_id: this.data_invoice.status_id,
          invoice_category_id: this.data_invoice.invoice_category_id,
          original_pending_amount: this.totals_invoices.pending_amount,
          original_total_paid: this.totals_invoices.total_paid,
          original_total_to_pay: this.totals_invoices.pending_amount,
          original_currency_code: this.data_invoice.currency_code,
          original_currency_id: this.data_invoice.currency_id,
          paid_base_usd: 0,
          send_missing: false,
          missing_amount: 0,
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async copyInvoiceNumber() {
      const number = this.data_invoice?.invoice_number;
      if (!number) return;
      try {
        await navigator.clipboard.writeText(number);
      } catch (e) {
        const el = document.createElement("textarea");
        el.value = number;
        el.style.position = "fixed";
        el.style.opacity = "0";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
      }
      this.$toast.success("Número de factura copiado");
    },
    async loadLogo() {
      if (this.data_invoice.image_storage != null) {
        this.locationImage = await this.get_storage(this.data_invoice.image_storage);
      } else {
        this.locationImage = null;
      }
      const request = await this.api_Post("accounting/get_calendar_accounting", {
        business_unit: this.data_invoice.business_unit_id,
        module: 4,
      });
      if (request.status == 200) {
        const data = await request.json();
        if (data.length > 0 && data[0].from_date) {
          this.dates_accounting.start_date = moment(data[0]?.from_date).format("YYYY-MM-DD");
          this.dates_accounting.end_date = moment(data[0].to_date).format("YYYY-MM-DD");
        }
      }
    },
    currencyFormat(value) {
      if (value === null || value === undefined) return "0.00";
      return parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    getInitials(name) {
      if (!name) return "";
      const parts = name.split(" ");
      let initials = "";
      for (let i = 0; i < Math.min(parts.length, 2); i++) {
        if (parts[i].length > 0 && parts[i] !== "") {
          initials += parts[i][0];
        }
      }
      return initials.toUpperCase();
    },
    getDate(date, type) {
      let newDate = "";
      if (type == 1) {
        newDate = moment(date).format("DD/MM/YYYY hh:mm:ss A").toString();
      }
      if (type == 2) {
        newDate = moment(date).format("DD-MM-YYYY").toString();
      }
      if (type == 3) {
        newDate = moment(date).format("DD-MMMM-YYYY").toString();
      }
      return newDate;
    },
    getDocumentTypeName(documentNumber) {
      if (!documentNumber) return "Documento no Identificado";
      // Extract the two digits after the first character
      const documentTypeCode = documentNumber.slice(1, 3);

      // Comprehensive mapping of DGII document type codes to names
      const types = {
        // Facturas
        "31": "Factura de Crédito Fiscal Electrónica",
        "32": "Factura de Consumo Electrónica",
        "33": "Nota de Débito Electrónica",
        "34": "Nota de Crédito Electrónica",
        "36": "Cotización",

        // Otros documentos fiscales
        "01": "Factura de Crédito Fiscal",
        "02": "Factura de Consumo",
        "03": "Nota de Débito",
        "04": "Nota de Crédito",
        "11": "Gastos Menores",
        "12": "Registro Único de Proveedores (RUP)",
        "13": "Comprobante Fiscal Simple",
        "14": "Comprobante Fiscal Gubernamental",
        "15": "Comprobante Fiscal Especial",

        // Documentos de exportación
        "41": "Comprobante Electrónico de Compras",
        "43": "Comprobante Electrónico para Gastos Menores",
        "44": "Comprobante Electrónico para Regímenes Especiales",
        "45": "Comprobante Electrónico Gubernamental",
        "46": "Comprobante Electrónico para Exportaciones",
        "47": "Comprobante Electrónico para Pagos al Exterior",
      };

      // Return the document type name or a default
      return types[documentTypeCode] || "Documento no Identificado";
    },
    async saveCampos() {
      let set_update = false
      let data = {
        id: this.data_invoice.invoice_id,
        supplier_invoice_number: null,
        supplier_invoice_voucher: null,
        account_date: null
      };
      if (this.inputs_to_update.set_accounting_date != this.data_invoice.account_date) {
        data.account_date = this.inputs_to_update.set_accounting_date;
        set_update = true;
      }
      if (this.inputs_to_update.supplier_invoice_number != this.data_invoice.supplier_invoice_number) {
        data.supplier_invoice_number = this.inputs_to_update.supplier_invoice_number;
        set_update = true;
      }
      if (this.inputs_to_update.supplier_invoice_voucher != this.data_invoice.supplier_invoice_voucher) {
        data.supplier_invoice_voucher = this.inputs_to_update.supplier_invoice_voucher;
        set_update = true;
      }
      if (set_update == false) {
        this.$toast.info("No hay cambios para guardar");
        return;
      }
      const responseInvoice = await this.api_Post("income/update_invoice_supplier_data", data);

      if (responseInvoice.status == 200) {
        this.getData();
        this.dialogCampos = false;
        this.$toast.success("Actualizado");
      } else {
        this.$toast.error("Error al actualizar");
      }
    },
    async getData() {
      this.loading = true;
      this.id_invoice = this.$route.params.id;

      if (window.history.length > 1) {
        this.hasPreviousPage = true;
      } else {
        this.hasPreviousPage = false;
      }

      const responseInvoice = await this.api_Post("income/search_invoice_header", {
        number: this.id_invoice,
      });

      if (responseInvoice.status == 200) {
        let data = await responseInvoice.json();
        this.data_invoice = data[0];
        this.loading = false;
        const responseInvoiceDetails = await this.api_Post(
          "income/search_invoice_details",
          {
            number: this.id_invoice,
          }
        );
        let in_details = await responseInvoiceDetails.json();
        this.invoice_details = in_details;

        const responseInvoicePayments = await this.api_Post(
          "income/search_invoice_payments",
          {
            number: this.id_invoice,
          }
        );
        let in_payments = await responseInvoicePayments.json();
        this.paymentsInvoice = in_payments;

        const responseInvoiceTotals = await this.api_Post(
          "income/search_invoice_totals",
          {
            number: this.id_invoice,
          }
        );
        let in_totals = await responseInvoiceTotals.json();
        this.totals_invoices =
          in_totals.length > 0
            ? in_totals[0]
            : {
              pending_amount: 0,
              total_paid: 0,
              total_credits: 0,
              total_debits: 0,
              total_withholdings: 0,
            };

        const responseInvoiceWarehouse = await this.api_Post(
          "income/search_invoice_warehouse",
          {
            number: this.id_invoice,
          }
        );
        this.warehouse_details = await responseInvoiceWarehouse.json();

        const responseInvoiceGroups = await this.api_Post(
          "income/search_invoice_groups",
          {
            number: this.id_invoice,
          }
        );
        let in_groups = await responseInvoiceGroups.json();
        this.invoice_groups = in_groups;

        if (data[0].use_ecf) {
          const responseInvoiceExistsDgii = await this.api_Post(
            "income/search_invoice_exists_dgii",
            {
              ncf_invoice_number: data[0].invoice_ncf,
              business_unit_rnc: data[0].business_unit_rnc
            }
          );
          let exits_in_dgii = await responseInvoiceExistsDgii.json();

          if (exits_in_dgii.length > 0) {
            if (exits_in_dgii[0].Estado == "ACEPTADO") {
              this.is_valid_dgii = true;
            }
          }

          if (!this.is_valid_dgii && data[0].invoice_ncf != null) {
            await this.loadDgiiStatus();
          }
        }
        const exists = this.$store.state.auth.all_locations.some(
          (location) => location.id === this.data_invoice.location_id
        );

        if (exists == false) {
          this.$router.push({ name: "Home" });
        }

        //  if (this.data_invoice.recorded == true) {
        const responseAccountig = await this.api_Post("accounting/payment_accounting", {
          filters: `  where invoice_id =${this.data_invoice.invoice_id} and invoice_note_id isnull`,
        });
        if (responseAccountig.status == 200) {
          this.accounting = await responseAccountig.json();
        }
        const responseNoteCredit = await this.api_Post("income/note_list", {
          filters: `  where invoice_id =${this.data_invoice.invoice_id}`,
        });
        if (responseNoteCredit.status == 200) {
          const allNotes = await responseNoteCredit.json();
          this.note_credits = allNotes.filter(n => n.note_type === 'CREDIT');
          this.note_debits = allNotes.filter(n => n.note_type === 'DEBIT');
        }

        //}
        if (this.data_invoice.invoice_groups != null) {
          let dataInvoice = this.data_invoice.invoice_details;
          const groupedData = dataInvoice.reduce((acc, currentItem) => {
            const itemId = currentItem.item_id;

            if (!acc[itemId]) {
              // Si el item_id no existe en el objeto acumulador, lo agrega
              acc[itemId] = { ...currentItem, quantity: 0 };
            }

            // Suma la cantidad al item_id correspondiente
            acc[itemId].quantity += currentItem.quantity;

            return acc;
          }, {});

          // Convierte el objeto de resultados de nuevo en un array
          const resultArray = Object.values(groupedData);
          this.data_invoice.invoice_details = resultArray;
          // Muestra el resultado
        }

        this.loadLogo();
        this.itemsFiles = this.data_invoice.storage_json;

        if (this.data_invoice.storage_json == null) {
        } else {
          this.storage_json = this.data_invoice.storage_json;
        }
        //busca recepciones
        if (this.data_invoice.order_id != null) {
          const responseEntry = await this.api_Post("shopping/search_entry_order", {
            order_id: this.data_invoice.order_id,
            filters: " AND INVOICE_ID=" + this.data_invoice.invoice_id,
          });
          if (responseEntry.status == 200) {
            this.data_entry_order = await responseEntry.json();
          }
        }
      } else {
        this.$toast.error("error al cargar la factura!");
      }
      const inv_data = Object.assign({}, this.data_invoice);
      this.inputs_to_update = {
        supplier_invoice_number: inv_data.supplier_invoice_number,
        supplier_invoice_voucher: inv_data.supplier_invoice_voucher,
        set_accounting_date: inv_data.account_date,
      };
      this.loading = false;
    },

    async cancelInvoice() {
      let result = await this.api_Post("income/cancel_invoice", {
        invoice_id: this.data_invoice.invoice_id,
        user_id: this.$store.state.auth.user.user.user_id,
      });
      if (result.status == 200) {
        this.$toast.success("Factura anulada");
        this.dialogCancelInvoice = false;
        this.getData();
      } else {
        this.$toast.error("Error al anular la factura");
      }
    },
    async loadDgiiStatus() {
      try {
        const response = await this.api_Post("income/search_invoice_dgii_status", {
          ncf_invoice_number: this.data_invoice.invoice_ncf,
          business_unit_rnc: this.data_invoice.business_unit_rnc,
        });
        this.dgii_status = response.status == 200 ? await response.json() : null;
      } catch (error) {
        console.error("Error consultando estado DGII:", error.message);
        this.dgii_status = null;
      }
    },
    // MensajeRespuesta puede ser texto plano o el JSON de la DGII ({ estado, mensajes: [{ codigo, valor }] })
    parseDgiiMessage(raw) {
      if (!raw) return { estado: null, mensajes: [] };
      try {
        const parsed = JSON.parse(raw);
        const mensajes = (parsed.mensajes || [])
          .filter((m) => m && m.valor)
          .map((m) => ({ codigo: m.codigo, valor: m.valor }));
        return { estado: parsed.estado || null, mensajes };
      } catch (e) {
        return { estado: null, mensajes: [{ codigo: null, valor: raw }] };
      }
    },
    // Extrae mensajes legibles de la respuesta de la API DGII, sea cual sea su forma
    extractDgiiMessages(body) {
      if (body == null || body === "") return [];
      if (typeof body === "string") return [body];

      const messages = [];
      const push = (value) => {
        if (value == null || value === "") return;
        if (Array.isArray(value)) return value.forEach(push);
        if (typeof value === "object") {
          if (value.valor) return messages.push(value.codigo ? `${value.codigo}: ${value.valor}` : value.valor);
          return Object.entries(value).forEach(([key, val]) =>
            [].concat(val).forEach((v) => messages.push(`${key}: ${typeof v === "object" ? JSON.stringify(v) : v}`))
          );
        }
        messages.push(String(value));
      };

      push(body.message);
      push(body.mensaje);
      push(body.error);
      push(body.title);
      push(body.detail);
      push(body.errors);
      push(body.mensajes);
      if (body.data) {
        push(body.data.mensaje);
        push(body.data.mensajes);
        push(body.data.errors);
      }
      return [...new Set(messages)];
    },
    async sendToDGII() {
      if (this.loading_dgii) return;
      this.loading_dgii = true;
      this.dgii_send_result = null;
      this.show_dgii_raw = false;

      let stage = "json";
      try {
        const resultado = await this.get_dgii_json(this.data_invoice.invoice_number);

        const business = (this.$store.state.auth.bussines_units || []).find(
          (element) => element.id == this.data_invoice.business_unit_id
        );
        if (!business || !business.ambiente) {
          throw new Error("La unidad de negocio no tiene ambiente DGII configurado");
        }

        stage = "api";
        const response = await fetch(
          `${process.env.VUE_APP_API_DGII}api/${business.ambiente}/${resultado.ECF.Encabezado.Emisor.RNCEmisor}/Invoice/create`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": "dev-dgii-ecf-api-key-2023",
            },
            body: JSON.stringify(resultado),
          }
        );

        const text = await response.text();
        let body = text;
        try {
          body = JSON.parse(text);
        } catch (e) {
          // respuesta no JSON: se muestra como texto
        }

        const secure_code = body && body.data && body.data.codigoSeguridad;
        if (response.ok && secure_code) {
          await this.api_Post("income/update_secure_code", {
            code: secure_code,
            invoice_id: this.data_invoice.invoice_number,
          });
        }

        this.dgii_send_result = {
          ok: response.ok,
          stage,
          status: response.status,
          messages: this.extractDgiiMessages(body),
          raw: typeof body === "string" ? body : JSON.stringify(body, null, 2),
          date: new Date(),
        };
      } catch (error) {
        console.error("Error enviando a DGII:", error);
        // fetch solo lanza TypeError cuando no hubo respuesta (red, firewall, TLS, CORS)
        const connectionError = stage == "api" && error instanceof TypeError;
        this.dgii_send_result = {
          ok: false,
          stage,
          status: null,
          messages: connectionError
            ? [
                `La petición a ${process.env.VUE_APP_API_DGII} no obtuvo respuesta (${error.message}). ` +
                  "Esto no es una respuesta de la DGII: la factura no llegó a enviarse.",
                "Verifique la conexión de este equipo con la API (red, VPN o firewall) o reenvíela desde otro equipo.",
              ]
            : [error.message],
          raw: error.stack || error.message,
          date: new Date(),
        };
      }

      this.loading_dgii = false;
      await this.getData();

      if (this.is_valid_dgii) {
        this.$toast.success("Factura aceptada por la DGII");
      } else {
        const result = this.dgii_send_result;
        if (result && result.stage == "api" && result.status == null) {
          this.$toast.error("No se pudo conectar con la API DGII desde este equipo/red. La factura no se envió.");
        } else if (result && result.stage == "json") {
          this.$toast.error("Error generando el e-CF. La factura no se envió.");
        } else {
          this.$toast.error("La factura no fue aceptada. Revise la respuesta de la DGII en la factura.");
        }
      }
    },
    getDgiiDate(date) {
      // dgii."Invoices"."FechaCreacion" se guarda en UTC (FechaActualizacion no: viene en hora local)
      return date ? moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A") : "";
    },

    async accountingInvoice() {
      try {
        this.loading_accounting = true;
        let result = await this.api_Post("income/accounting_invoice", {
          invoice_id: this.data_invoice.invoice_id,
        });
        if (result.status == 200) {
          this.getData();
          this.$toast.success("Factura contabilizada");
          this.dialogAccountingInvoice = false;
        } else {
          this.$toast.error("Error al contabilizar la factura");
        }
        this.loading_accounting = false;
      } catch (error) {
        console.error("Error al contabilizar la factura:", error.message);
      }
    },
    async cancelAccountingInvoice() {
      try {
        this.loading_accounting = true;
        let result = await this.api_Post("income/accounting_invoice_cancel", {
          invoice_id: this.data_invoice.invoice_id,
        });
        if (result.status == 200) {
          this.$toast.success("Factura descontabilizada");
          this.dialogCancelAccountingInvoice = false;
          this.getData();
        } else {
          this.$toast.error("Error al descontabilizar la factura");
        }
        this.loading_accounting = false;
      } catch (error) {
        console.error("Error al descontabilizar la factura:", error.message);
      }
    },

    getTotalDebito() {
      return this.accounting.reduce((acc, entry) => {
        return entry.entry_type_id === 1 ? acc + parseFloat(entry.amount) : acc;
      }, 0);
    },
    getTotalCredito() {
      return this.accounting.reduce((acc, entry) => {
        return entry.entry_type_id === 2 ? acc + parseFloat(entry.amount) : acc;
      }, 0);
    },
    getTotalDebitoBase() {
      return this.accounting.reduce((acc, entry) => {
        return entry.entry_type_id === 1
          ? acc + parseFloat(entry.amount * entry.currency_rate)
          : acc;
      }, 0);
    },
    getTotalCreditoBase() {
      return this.accounting.reduce((acc, entry) => {
        return entry.entry_type_id === 2
          ? acc + parseFloat(entry.amount * entry.currency_rate)
          : acc;
      }, 0);
    },
    async viewAddtached(item) {
      this.loadingAttachment = true;
      this.dialogAttached = true;

      try {
        if (item && item.key) {
          const resp = await fetch(this.spaces_file_url(item.key));
          const blob = await resp.blob();
          if (this.selectedAttached && this.selectedAttached.startsWith('blob:')) {
            URL.revokeObjectURL(this.selectedAttached);
          }
          this.selectedAttached = URL.createObjectURL(blob);
        } else {
          this.selectedAttached = '';
        }
      } catch (err) { this.selectedAttached = ''; }

      this.loadingAttachment = false;
    },
    async onFileChange() {
      try {
        const fileInput = document.getElementById("fileInput");
        const file = fileInput.files[0];
        if (!file) return;

        const result = await this.upload_to_spaces(file, "invoices_atached");

        this.storage_json.push({
          description: "File " + (this.storage_json.length + 1).toString(),
          url: result.url,
          key: result.key,
          name: file.name,
        });

        const responseRequest = await this.api_Post("income/attaches_invoices", {
          id: this.data_invoice.invoice_id,
          json: this.storage_json,
        });
        if (responseRequest.status == 200) {
          this.$toast.success("Guardado!");
          this.getData();
        } else {
          this.$toast.error("error al cargar!");
        }
      } catch (e) {
        this.$toast.error("error " + e.message);
      }
    },

    confirmDeleteFile(file, fidx) {
      this.fileToDelete = file;
      this.fileToDeleteIndex = fidx;
      this.dialogDeleteFile = true;
    },
    async deleteFile() {
      this.loadingDeleteFile = true;
      try {
        if (this.fileToDelete?.key) {
          await this.delete_from_spaces(this.fileToDelete.key);
        }
        const updatedJson = this.storage_json.filter((_, i) => i !== this.fileToDeleteIndex);
        const res = await this.api_Post("income/attaches_invoices", {
          id: this.data_invoice.invoice_id,
          json: updatedJson,
        });
        if (res.status == 200) {
          this.$toast.success("Archivo eliminado");
          this.dialogDeleteFile = false;
          this.getData();
        } else {
          this.$toast.error("Error al eliminar el archivo");
        }
      } catch (e) {
        this.$toast.error("Error: " + e.message);
      }
      this.loadingDeleteFile = false;
    },
    takeImage() {
      //this.fileInput.click();
      document.getElementById("fileInput").click();

      //this.this.dialogImage = true;
    },
    downloadInvoice() {
      this.$router.push({
        name: "DownloadInvoice",
        params: { id: this.data_invoice.invoice_id },
      });
    },
    selectItem(item) {
      this.selectedEntity = item;
      this.dialogSearch = false;
    },
    selectPayment(item) {
      this.selectedPayments = item;
      this.dialogPayments = false;
    },
    deleteItem(item) {
      let editIndex = this.selectedPayments.indexOf(item);

      this.selectedPayments.splice(editIndex, 1);
    },
    async downloadInvoiceExcel() {
      // --- 1. DATOS DE PRUEBA ---
      const datosFactura = {
        detalles: {
          terminosEnvio: "DDU. MD",
          terminosPago: "NET 30 DAYS",
          viaje: "",
          poServicio: "",
          facturaCliente: "CV-DKT231-2025",
        },
      };

      // --- 2. CREACIÓN Y CONFIGURACIÓN DEL DOCUMENTO ---
      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("Invoice", {
        pageSetup: {
          paperSize: 9, // A4
          orientation: "portrait",
          fitToWidth: 1,
          fitToHeight: 0,
        },
      });

      worksheet.pageSetup.printTitlesRow = "1:27";
      worksheet.views = [{ showGridLines: false }];

      worksheet.columns = [
        { width: 5 }, // A
        { width: 12 }, // B
        { width: 15 }, // C
        { width: 8 }, // D
        { width: 28 }, // E (Descripción parte 1)
        { width: 15 }, // F (Descripción parte 2)
        { width: 15 }, // G (antes F)
        { width: 10 }, // H (antes G)
        { width: 15 }, // I (antes H)
      ];

      // --- 3. ESTILOS REUTILIZABLES ---
      const fullBorderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      const totalRowBorderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "double" },
        right: { style: "thin" },
      };

      // --- 4. ENCABEZADO Y LÍNEAS SEPARADORAS ---
      worksheet.mergeCells("A1:D1");
      worksheet.getCell("A1").value = this.data_invoice.business_unit_description;
      worksheet.getCell("A1").font = { name: "Calibri", size: 14, bold: true };
      worksheet.mergeCells("E1:I2");
      worksheet.getCell("E1").value = "INVOICE";
      worksheet.getCell("E1").font = { name: "Calibri", size: 28, bold: true };
      worksheet.getCell("E1").alignment = { vertical: "middle", horizontal: "right" };
      worksheet.getCell("A2").value = this.data_invoice.business_unit_description;
      worksheet.getCell("A3").value = this.data_invoice.business_unit_address;
      worksheet.getCell("A4").value =
        this.data_invoice.business_unit_phone || "Phone: (809) 242-8820 Ext.: 2270";
      worksheet.getCell("A5").value = `RNC: ${this.data_invoice.business_unit_rnc}`;
      worksheet.mergeCells("E3:I3");
      worksheet.getCell("E3").value = this.data_invoice.invoice_number;
      worksheet.getCell("E3").alignment = { horizontal: "right" };
      worksheet.getCell("E3").font = {
        color: { argb: "FF999999" }, // Gris claro
        bold: true,
      };
      const addSeparatorLine = (rowNumber) => {
        worksheet.mergeCells(`A${rowNumber}:I${rowNumber}`);
        worksheet.getCell(`A${rowNumber}`).border = { bottom: { style: "thin" } };
      };
      addSeparatorLine(7);
      // --- 5. BLOQUE DE INFORMACIÓN (CLIENTE Y FACTURA) --- this.data_invoice
      const addres = this.data_invoice.entity_contact_json.find(
        (element) => element.id_type === 10
      );
      const email = this.data_invoice.entity_contact_json.find(
        (element) => element.id_type === 5
      );

      let shipto = this.data_invoice?.metadata?.ship_to;
      let default_shipto = this.data_invoice.entity_contact_json.find(
        (element) => element.id_type === 16
      );
      if (shipto == undefined && default_shipto != undefined) {
        shipto = default_shipto.description;
      }

      const customer_address =
        addres != undefined ? addres.description : "No address provided";
      const customer_email = email != undefined ? email.description : "No email provided";
      const customer_shipto = shipto != undefined ? shipto : "No shipto provided";
      const startRowInfo = 8;
      // ... (Esta sección no cambia, se mantiene la de la respuesta anterior)
      worksheet.getCell(`A${startRowInfo}`).value = "CUSTOMER:";
      worksheet.getCell(`A${startRowInfo}`).font = { bold: true };
      worksheet.mergeCells(`A${startRowInfo + 1}:D${startRowInfo + 6}`);
      worksheet.getCell(
        `A${startRowInfo + 1}`
      ).value = `${this.data_invoice.entity_name}\n${customer_address},\n\nATTN: ACCOUNTS PAYABLE\n${customer_email}`;
      worksheet.getCell(`A${startRowInfo + 1}`).alignment = {
        wrapText: true,
        vertical: "top",
      };
      worksheet.getCell(`A${startRowInfo + 7}`).value = "SHIPTO:";
      worksheet.getCell(`A${startRowInfo + 7}`).font = { bold: true };
      worksheet.mergeCells(`A${startRowInfo + 8}:D${startRowInfo + 10}`);
      worksheet.getCell(`A${startRowInfo + 8}`).value = `${customer_shipto}`;
      worksheet.getCell(`A${startRowInfo + 8}`).alignment = {
        wrapText: true,
        vertical: "top",
      };
      const labelsInfo = [
        "INVOICE #:",
        "INVOICE DATE:",
        "DUE DATE:",
        "SHIPMENT TERMS:",
        "PAYMENT TERMS:",
        "VOYAGE#:",
        "SERVICE PO.:",
        "Factura del Cliente:",
      ];

      const valuesInfo = [
        this.data_invoice.metadata.customerInvoice,
        moment(this.data_invoice.emission_date).format("DD/MM/YYYY"),
        moment(this.data_invoice.expire_at).format("DD/MM/YYYY"),
        datosFactura.detalles.terminosEnvio,
        datosFactura.detalles.terminosPago,
        datosFactura.detalles.viaje,
        this.data_invoice.metadata.servicePO,
        this.data_invoice.metadata.customerInvoice,
      ];

      labelsInfo.forEach((label, index) => {
        worksheet.mergeCells(`F${startRowInfo + index}:G${startRowInfo + index}`);
        worksheet.getCell(`F${startRowInfo + index}`).value = label;
        worksheet.getCell(`F${startRowInfo + index}`).alignment = {
          wrapText: true,
          vertical: "top",
          horizontal: "right",
        };
        worksheet.getCell(`F${startRowInfo + index}`).font = { bold: true };
        worksheet.mergeCells(`H${startRowInfo + index}:I${startRowInfo + index}`);
        worksheet.getCell(`H${startRowInfo + index}`).value = valuesInfo[index];
        worksheet.getCell(`H${startRowInfo + index}`).alignment = {
          wrapText: true,
          vertical: "top",
          horizontal: "left",
        };
      });
      addSeparatorLine(20);

      // --- 6. BLOQUE DE CONTENIDO DEL PRODUCTO ---
      // ... (Esta sección no cambia, se mantiene la de la respuesta anterior)

      const startRowContent = 21;
      const labelsContent = ["CONTENT:", "COLOR:", "COLOR NAME:", "YARN LOT:"];
      const valuesContent =
        this.data_invoice.metadata == undefined
          ? ["", "", "", ""]
          : [
            this.data_invoice.metadata.content,
            this.data_invoice.metadata.color,
            this.data_invoice.metadata.colorName,
            this.data_invoice.metadata.yarnLot,
          ];
      labelsContent.forEach((label, index) => {
        worksheet.mergeCells(`A${startRowContent + index}:B${startRowContent + index}`);
        worksheet.getCell(`A${startRowContent + index}`).value = label;
        worksheet.getCell(`A${startRowContent + index}`).font = { bold: true };
        worksheet.mergeCells(`C${startRowContent + index}:D${startRowContent + index}`);
        worksheet.getCell(`C${startRowContent + index}`).value = valuesContent[index];
      });
      const labelsProd = [
        "YARN POUNDS ASSIGNED (ENTIRE PO):",
        "FINISHED POUNDS OUT (TOTAL PRODUCED):",
        "WORKING LOSS:",
      ];
      const valuesProd =
        this.data_invoice.metadata == undefined
          ? ["", "", ""]
          : [
            parseInt(this.data_invoice.metadata.yarnPoundAssigned),
            parseInt(this.data_invoice.metadata.finishedPoundsOut),
            this.data_invoice.metadata.workingLoss,
          ];
      labelsProd.forEach((label, index) => {
        worksheet.mergeCells(`E${startRowContent + index}:H${startRowContent + index}`);
        worksheet.getCell(`E${startRowContent + index}`).value = label;
        worksheet.getCell(`I${startRowContent + index}`).value = valuesProd[index];
        worksheet.getCell(`I${startRowContent + index}`).alignment = {
          horizontal: "right",
        };
      });
      worksheet.getCell(`I${startRowContent}`).numFmt = "#,##0.00";
      worksheet.getCell(`I${startRowContent + 1}`).numFmt = "#,##0.00";
      worksheet.getCell(`I${startRowContent + 2}`).numFmt = "0.00%";
      addSeparatorLine(25);

      // --- 7. TABLA DE ÍTEMS CON BORDES REFORZADOS ---
      const startRowItems = 27;
      const headerItems = [
        "LN.",
        "SERVICE",
        "ITEM #",
        "Color",
        "DESCRIPTION",
        "",
        "POUNDS OUT",
        "COST/LB",
        "TOTAL COST",
      ];
      const headerRow = worksheet.getRow(startRowItems);
      headerRow.values = headerItems;
      headerRow.font = { bold: true };
      headerRow.alignment = { vertical: "middle", horizontal: "center" };
      headerRow.eachCell((cell) => {
        cell.border = fullBorderStyle;
      });
      worksheet.mergeCells(`E${startRowItems}:F${startRowItems}`);
      let sum_item_quantity = 0;
      let ln = 1;
      this.invoice_details.forEach((item) => {
        const rowData = [
          ln,
          "",
          item.supplier_code || "",
          this.data_invoice.metadata.color,
          item.item_name,
          "",
          item.quantity,
          item.price,
          item.total_amount,
        ];
        const addedRow = worksheet.addRow(rowData);
        worksheet.mergeCells(`E${addedRow.number}:F${addedRow.number}`);
        ln++;
        sum_item_quantity += parseFloat(item.quantity);
        addedRow.eachCell((cell, colNumber) => {
          cell.border = fullBorderStyle; // Aplicar el estilo de borde completo
          if (colNumber >= 7) {
            cell.alignment = { horizontal: "right" };
            cell.numFmt = "#,##0.00";
          }
          if (colNumber === 1) cell.alignment = { horizontal: "center" };
        });
      });

      // --- 8. PIE DE TABLA Y TOTAL FINAL ---
      const totalRowNumber = worksheet.lastRow.number + 1;
      worksheet.mergeCells(`A${totalRowNumber}:E${totalRowNumber}`);
      const cellTotalLabel = worksheet.getCell(`A${totalRowNumber}`);
      cellTotalLabel.value = "TOTAL PCS/LBS/YDS";
      cellTotalLabel.font = { bold: true };
      cellTotalLabel.alignment = { horizontal: "right", vertical: "middle" };

      // Aplicar bordes a la fila de total
      cellTotalLabel.border = totalRowBorderStyle;
      // Rellenar los bordes de las celdas mergeadas
      for (let i = 2; i <= 6; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${totalRowNumber}`).border = {
          top: { style: "thin" },
          bottom: { style: "double" },
        };
      }

      const cellTotalPounds = worksheet.getCell(`G${totalRowNumber}`);
      cellTotalPounds.value = sum_item_quantity;
      cellTotalPounds.font = { bold: true };
      cellTotalPounds.numFmt = "#,##0.00";
      cellTotalPounds.alignment = { horizontal: "right" };
      cellTotalPounds.border = totalRowBorderStyle;

      worksheet.getCell(`H${totalRowNumber}`).border = {
        top: { style: "thin" },
        bottom: { style: "double" },
      };
      worksheet.getCell(`I${totalRowNumber}`).border = totalRowBorderStyle;

      const remitRow1 = totalRowNumber + 2;
      worksheet.mergeCells(`A${remitRow1}:I${remitRow1}`);
      worksheet.getCell(`A${remitRow1}`).value =
        "PLEASE REMIT THE FOLLOWING AMOUNT:    US$ " +
        this.currencyFormat(this.data_invoice.total_amount);
      worksheet.getCell(`A${remitRow1}`).font = { name: "Calibri", size: 14, bold: true };
      worksheet.getCell(`A${remitRow1}`).alignment = { horizontal: "right" };
      // const remitRow2 = totalRowNumber + 3;
      // worksheet.mergeCells(`A${remitRow2}:H${remitRow2}`);
      // worksheet.getCell(`A${remitRow2}`).value = this.data_invoice.total_amount;
      // worksheet.getCell(`A${remitRow2}`).font = { name: 'Calibri', size: 16, bold: true };
      // worksheet.getCell(`A${remitRow2}`).alignment = { horizontal: 'center' };
      // worksheet.getCell(`A${remitRow2}`).numFmt = '#,##0.00';

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      //{{report_title.title}} {{report_title.is_default?'':report_title.union+report_title.origin+' '+report_title.date_format}}
      link.download = `${this.data_invoice.invoice_number}.xlsx`;
      link.click();
    },
    updateSupplierInvoiceNumber(value) {
      if (this.data_invoice) {
        this.data_invoice.supplier_invoice_number = value;
      }
    },
    updateSupplierInvoiceVoucher(value) {
      if (this.data_invoice) {
        this.data_invoice.supplier_invoice_voucher = value;
      }
    },
    save_acounting_invoice() { },
  },
};
</script>
